/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SchoolBell-E API
 * SchoolBell 레거시 플랫폼 리소스 OAuth AS + RS
 * OpenAPI spec version: 1.0
 */
import {
  HttpClient,
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import {
  Observable
} from 'rxjs';

import type {
  AddMemberDto,
  AddTeamMemberDto,
  AdoptLegacySessionDto,
  AssignOrgMemberLabelDto,
  AuthenticatorRequestContextDto,
  AuthenticatorRequestCreatedDto,
  AuthenticatorRequestResultDto,
  AuthenticatorVerificationResultDto,
  BatchManagedUsersBodyDto,
  BatchManagedUsersResultDto,
  BatchMembersBodyDto,
  BatchOrgTeamsBodyDto,
  BatchUpdateOrgMemberLabelAssignmentsDto,
  ChangePasswordBodyDto,
  ConfirmMemberPickerSessionDto,
  ConfirmPhoneChangeDto,
  ConnectServiceBodyDto,
  ConnectServiceResponseDto,
  ConnectViaMagicLinkBodyDto,
  ConnectableServiceDto,
  ContinuityLinkDto,
  CreateAuthenticatorRequestDto,
  CreateContinuityLinkDto,
  CreateManagedUserBodyDto,
  CreateOAuthClientAppDto,
  CreateOAuthClientAppScopeRequestDto,
  CreateOrgDto,
  CreateOrgMemberLabelDto,
  CreateOrgTeamDto,
  CreateStaffInvitationDto,
  CreateWebhookEndpointDto,
  CreatedManagedUserDto,
  DeletedTargetListResponseDto,
  DeletedTargetsControllerListDeletedLabelsParams,
  DeletedTargetsControllerListDeletedMembersParams,
  DeliveryReportByTokenBodyDto,
  DestroyStaffSessionsResponseDto,
  DisconnectServiceBodyDto,
  DissolveOrgDto,
  EmailOtpRequestBodyDto,
  EmailOtpVerifyBodyDto,
  ExchangeMemberPickerSessionDto,
  GrantOrgPermissionDto,
  InteractionDetailsDto,
  InteractionRedirectDto,
  IssuedSessionResponseDto,
  ListMyInvitationsResponseDto,
  ListMyOrgMembersResponseDto,
  ListNotificationsResponseDto,
  ListOrgInvitationsResponseDto,
  ListWebhookEventsResponseDto,
  LoginBodyDto,
  LookupPushDeliveriesResponseDto,
  LookupStaffContactsDto,
  LookupStaffContactsResponseDto,
  MagicLinkEntryResponseDto,
  MarkAllNotificationsReadResponseDto,
  MeOrgsControllerListMyOrgsParams,
  MeResponseDto,
  MemberPickerSelectionResultDto,
  MemberPickerSessionContextDto,
  MemberPickerSessionCreatedDto,
  MoveOrgTeamDto,
  MyOrgDto,
  MyOrgListResponseDto,
  OAuthConsentListResponseDto,
  OAuthServiceConnectionControllerListConnectableServicesParams,
  OrgAccessTokenBodyDto,
  OrgAccessTokenResponseDto,
  OrgAuditLogControllerListAuditLogParams,
  OrgAuditLogListResponseDto,
  OrgDissolveResultDto,
  OrgDto,
  OrgInvitationResponseDto,
  OrgInvitationsAdminControllerListParams,
  OrgManagedSessionBodyDto,
  OrgMemberDto,
  OrgMemberLabelDto,
  OrgMemberLabelListResponseDto,
  OrgMemberListResponseDto,
  OrgMembersControllerListMembersParams,
  OrgNotificationAcceptedDto,
  OrgPermissionDto,
  OrgPermissionListResponseDto,
  OrgRegionListResponseDto,
  OrgTeamDetailDto,
  OrgTeamDto,
  OrgTeamListResponseDto,
  OrgTeamsControllerListTeamMembersParams,
  OtpRequestBodyDto,
  OtpRequestResponseDto,
  OtpVerifyBodyDto,
  PasswordResetConfirmDto,
  PasswordResetRequestDto,
  PhoneChangeResultDto,
  PushDeliveriesControllerLookupParams,
  PutAppLayerSettingDto,
  PutAppServiceProfileDto,
  PutServiceUsageDto,
  RefreshTokenBodyDto,
  RegisterFcmDeviceDto,
  ReinviteResultDto,
  ReissueManagedCredentialBodyDto,
  ReissuedManagedCredentialDto,
  RejectAuthenticatorRequestDto,
  RejectInvitationDto,
  RejectOAuthClientDto,
  ReplayWebhookEventResponseDto,
  RequestPhoneChangeOtpDto,
  RevokeOAuthClientScopeDto,
  SeatAcceptanceDto,
  SelfProfileDto,
  SendOrgNotificationDto,
  ServiceUsageDto,
  SetMemberPositionsDto,
  SetOfflineAccessDto,
  SetWebhookSigningSecretDto,
  SetWebhookSigningSecretResultDto,
  SigninBodyDto,
  SignupBodyDto,
  SignupOtpVerifyBodyDto,
  SignupOtpVerifyResponseDto,
  SocialBodyDto,
  SocialCompleteBodyDto,
  SocialOtpRequestBodyDto,
  SocialOtpRequestResponseDto,
  SocialPendingResponseDto,
  SpinoffNotificationsControllerListParams,
  StaffDetailDto,
  StaffInvitationResponseDto,
  StaffListItemDto,
  StaffListResponseDto,
  StaffLoginDto,
  StaffLoginResponseDto,
  StaffManagementControllerListStaffParams,
  StaffOAuthAppApprovalRequestReviewControllerListParams,
  StaffOAuthAppScopeRequestReviewControllerListParams,
  StaffOAuthClientReviewControllerListParams,
  StaffOrgTaskLookupControllerListParams,
  StaffOrgTaskViewDto,
  StaffScopesResponseDto,
  StaffUserDeviceDto,
  StaffUserDevicesControllerLookupParams,
  StaffUserDto,
  SubmitOAuthAppClientDto,
  TeamAdminListResponseDto,
  TeamServiceSettingDto,
  UnreadCountResponseDto,
  UpdateEmbedOriginsDto,
  UpdateMemberDto,
  UpdateMemberSortKeyDto,
  UpdateOrgMemberLabelDto,
  UpdateOrgTeamDto,
  UpdateStaffDto,
  UpdateStaffRoleDto,
  UpdateStaffRoleResponseDto,
  UpdateStaffScopesDto,
  UpdateStaffScopesResponseDto,
  UpdateTeamMemberRoleDto,
  UpdateWebhookEndpointDto,
  VerifyAuthenticatorRequestDto,
  VisibleServiceDto,
  WebhookEndpointDto,
  WebhookEventAdminControllerListParams,
  WebhookEventDetailDto,
  WebhookSigningSecretStatusDto
} from './models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class SchoolBellEAPIService {
  private readonly http = inject(HttpClient);
/**
 * @summary 이메일 OTP 발송 (비밀번호 찾기 / 이메일 OTP 로그인). dry-run 모드에서는 dryRunCode 포함.
 */
 spinoffAuthControllerEmailOtpRequest<TData = OtpRequestResponseDto>(emailOtpRequestBodyDto: EmailOtpRequestBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerEmailOtpRequest<TData = OtpRequestResponseDto>(emailOtpRequestBodyDto: EmailOtpRequestBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerEmailOtpRequest<TData = OtpRequestResponseDto>(emailOtpRequestBodyDto: EmailOtpRequestBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerEmailOtpRequest<TData = OtpRequestResponseDto>(
    emailOtpRequestBodyDto: EmailOtpRequestBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/email-otp/request`,
      emailOtpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/email-otp/request`,
      emailOtpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/email-otp/request`,
      emailOtpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 이메일 OTP 인증 → 세션 발급
 */
 spinoffAuthControllerEmailOtpVerify<TData = IssuedSessionResponseDto>(emailOtpVerifyBodyDto: EmailOtpVerifyBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerEmailOtpVerify<TData = IssuedSessionResponseDto>(emailOtpVerifyBodyDto: EmailOtpVerifyBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerEmailOtpVerify<TData = IssuedSessionResponseDto>(emailOtpVerifyBodyDto: EmailOtpVerifyBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerEmailOtpVerify<TData = IssuedSessionResponseDto>(
    emailOtpVerifyBodyDto: EmailOtpVerifyBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/email-otp/verify`,
      emailOtpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/email-otp/verify`,
      emailOtpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/email-otp/verify`,
      emailOtpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 프로필 조회
 */
 spinoffSessionControllerMe<TData = MeResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 spinoffSessionControllerMe<TData = MeResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffSessionControllerMe<TData = MeResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffSessionControllerMe<TData = MeResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 비밀번호 변경 (인증 필요)
 */
 spinoffAuthControllerChangePassword<TData = void>(changePasswordBodyDto: ChangePasswordBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerChangePassword<TData = void>(changePasswordBodyDto: ChangePasswordBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerChangePassword<TData = void>(changePasswordBodyDto: ChangePasswordBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerChangePassword<TData = void>(
    changePasswordBodyDto: ChangePasswordBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/auth/me/password`,
      changePasswordBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/auth/me/password`,
      changePasswordBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/auth/me/password`,
      changePasswordBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 단체가 만든 소유 계정(전화·이메일·소셜 없음)이 학교에서 받은 6자 로그인 코드로 로그인한다. 코드는 단체 안에서만 유일하므로 단체 id(`{shard}:{id}`)를 함께 보낸다. 실패 응답은 코드 없음·만료·폐기·삭제·단체 id 형식 오류를 구분하지 않는다(401). 같은 IP 에서 실패가 반복되면 429 로 잠긴다.
 * @summary 단체 소유 계정 로그인 — 단체 id + 로그인 코드 → 세션 발급
 */
 orgManagedLoginControllerOrgManagedSession<TData = IssuedSessionResponseDto>(orgManagedSessionBodyDto: OrgManagedSessionBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgManagedLoginControllerOrgManagedSession<TData = IssuedSessionResponseDto>(orgManagedSessionBodyDto: OrgManagedSessionBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgManagedLoginControllerOrgManagedSession<TData = IssuedSessionResponseDto>(orgManagedSessionBodyDto: OrgManagedSessionBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgManagedLoginControllerOrgManagedSession<TData = IssuedSessionResponseDto>(
    orgManagedSessionBodyDto: OrgManagedSessionBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/org-managed/sessions`,
      orgManagedSessionBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/org-managed/sessions`,
      orgManagedSessionBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/org-managed/sessions`,
      orgManagedSessionBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary org access token 발급 — 현재 유효한 세션(personal/org 무관)으로 대상 org의 파생 access token을 발급한다. 세션 교체·쿠키 조작·refresh 발급 없음(stateless).
 */
 spinoffSessionControllerOrgToken<TData = OrgAccessTokenResponseDto>(orgAccessTokenBodyDto: OrgAccessTokenBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffSessionControllerOrgToken<TData = OrgAccessTokenResponseDto>(orgAccessTokenBodyDto: OrgAccessTokenBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffSessionControllerOrgToken<TData = OrgAccessTokenResponseDto>(orgAccessTokenBodyDto: OrgAccessTokenBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffSessionControllerOrgToken<TData = OrgAccessTokenResponseDto>(
    orgAccessTokenBodyDto: OrgAccessTokenBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/org-token`,
      orgAccessTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/org-token`,
      orgAccessTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/org-token`,
      orgAccessTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 전화번호 OTP 발송. dry-run 모드에서는 dryRunCode 포함.
 */
 spinoffAuthControllerOtpRequest<TData = OtpRequestResponseDto>(otpRequestBodyDto: OtpRequestBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerOtpRequest<TData = OtpRequestResponseDto>(otpRequestBodyDto: OtpRequestBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerOtpRequest<TData = OtpRequestResponseDto>(otpRequestBodyDto: OtpRequestBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerOtpRequest<TData = OtpRequestResponseDto>(
    otpRequestBodyDto: OtpRequestBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/otp/request`,
      otpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/otp/request`,
      otpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/otp/request`,
      otpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 전화 OTP 인증 → 세션 발급
 */
 spinoffAuthControllerOtpVerify<TData = IssuedSessionResponseDto>(otpVerifyBodyDto: OtpVerifyBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerOtpVerify<TData = IssuedSessionResponseDto>(otpVerifyBodyDto: OtpVerifyBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerOtpVerify<TData = IssuedSessionResponseDto>(otpVerifyBodyDto: OtpVerifyBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerOtpVerify<TData = IssuedSessionResponseDto>(
    otpVerifyBodyDto: OtpVerifyBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/otp/verify`,
      otpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/otp/verify`,
      otpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/otp/verify`,
      otpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 비밀번호 찾기 — OTP 확인 + 비밀번호 변경
 */
 userAuthControllerPasswordResetConfirm<TData = void>(passwordResetConfirmDto: PasswordResetConfirmDto, options?: HttpClientBodyOptions): Observable<TData>;
 userAuthControllerPasswordResetConfirm<TData = void>(passwordResetConfirmDto: PasswordResetConfirmDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 userAuthControllerPasswordResetConfirm<TData = void>(passwordResetConfirmDto: PasswordResetConfirmDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  userAuthControllerPasswordResetConfirm<TData = void>(
    passwordResetConfirmDto: PasswordResetConfirmDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/password-reset/confirm`,
      passwordResetConfirmDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/password-reset/confirm`,
      passwordResetConfirmDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/password-reset/confirm`,
      passwordResetConfirmDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 비밀번호 찾기 — OTP 발송 요청
 */
 userAuthControllerPasswordResetRequest<TData = void>(passwordResetRequestDto: PasswordResetRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 userAuthControllerPasswordResetRequest<TData = void>(passwordResetRequestDto: PasswordResetRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 userAuthControllerPasswordResetRequest<TData = void>(passwordResetRequestDto: PasswordResetRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  userAuthControllerPasswordResetRequest<TData = void>(
    passwordResetRequestDto: PasswordResetRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/password-reset/request`,
      passwordResetRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/password-reset/request`,
      passwordResetRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/password-reset/request`,
      passwordResetRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary refresh token 회전 — HttpOnly 쿠키(일반 로그인) 또는 body(매직링크 유래 sessionStorage 세션) 중 실제로 요청이 쓴 채널로만 응답한다(전송 채널 미러링, 쿠키 없이 body로 오면 쿠키를 세팅하지 않는다).
 */
 spinoffSessionControllerRefresh<TData = IssuedSessionResponseDto>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffSessionControllerRefresh<TData = IssuedSessionResponseDto>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffSessionControllerRefresh<TData = IssuedSessionResponseDto>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffSessionControllerRefresh<TData = IssuedSessionResponseDto>(
    refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/refresh`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/refresh`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/refresh`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 레거시(sbe-web-v4) refresh token으로 신규 first-party(SpinoffBffModule) 세션 발급 — v4 auth 도메인의 iframe 브로커 전용(CORS: LEGACY_AUTH_ORIGIN만 허용)
 */
 userAuthControllerAdoptLegacy<TData = void>(adoptLegacySessionDto: AdoptLegacySessionDto, options?: HttpClientBodyOptions): Observable<TData>;
 userAuthControllerAdoptLegacy<TData = void>(adoptLegacySessionDto: AdoptLegacySessionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 userAuthControllerAdoptLegacy<TData = void>(adoptLegacySessionDto: AdoptLegacySessionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  userAuthControllerAdoptLegacy<TData = void>(
    adoptLegacySessionDto: AdoptLegacySessionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/session/adopt-legacy`,
      adoptLegacySessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/session/adopt-legacy`,
      adoptLegacySessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/session/adopt-legacy`,
      adoptLegacySessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 신규 first-party(SpinoffBffModule) 세션(쿠키) 기준으로 레거시(sbe-web-v4) 세션을 함께 발급 — adopt-legacy의 반대 방향. v4 auth 도메인의 iframe 브로커 전용(CORS: LEGACY_AUTH_ORIGIN만 허용)
 */
 userAuthControllerProvisionLegacy<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 userAuthControllerProvisionLegacy<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 userAuthControllerProvisionLegacy<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  userAuthControllerProvisionLegacy<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/session/provision-legacy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/session/provision-legacy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/session/provision-legacy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 비밀번호 로그인
 */
 spinoffAuthControllerSignin<TData = IssuedSessionResponseDto>(signinBodyDto: SigninBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerSignin<TData = IssuedSessionResponseDto>(signinBodyDto: SigninBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerSignin<TData = IssuedSessionResponseDto>(signinBodyDto: SigninBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerSignin<TData = IssuedSessionResponseDto>(
    signinBodyDto: SigninBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/signin`,
      signinBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/signin`,
      signinBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/signin`,
      signinBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 로그아웃 (refresh token 폐기) — 쿠키 또는 body 중 요청이 쓴 채널만 정리한다(전송 채널 미러링). body로 왔으면 쿠키는 건드리지 않는다 — 다른 탭의 개인 로그인 세션을 지켜야 한다.
 */
 spinoffSessionControllerSignout<TData = void>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffSessionControllerSignout<TData = void>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffSessionControllerSignout<TData = void>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffSessionControllerSignout<TData = void>(
    refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/signout`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/signout`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/signout`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 비밀번호 회원가입 — `signupPhoneVerification`을 켠 앱은 phoneVerificationKey 필수
 */
 spinoffAuthControllerSignup<TData = IssuedSessionResponseDto>(signupBodyDto: SignupBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerSignup<TData = IssuedSessionResponseDto>(signupBodyDto: SignupBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerSignup<TData = IssuedSessionResponseDto>(signupBodyDto: SignupBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerSignup<TData = IssuedSessionResponseDto>(
    signupBodyDto: SignupBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/signup`,
      signupBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/signup`,
      signupBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/signup`,
      signupBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 가입 전 전화 OTP 검증 → 전화 소유 검증 키 발급(세션 없음). `signupPhoneVerification`을 켠 앱 전용. OTP 발송은 POST /auth/otp/request.
 */
 spinoffAuthControllerSignupOtpVerify<TData = SignupOtpVerifyResponseDto>(signupOtpVerifyBodyDto: SignupOtpVerifyBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerSignupOtpVerify<TData = SignupOtpVerifyResponseDto>(signupOtpVerifyBodyDto: SignupOtpVerifyBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerSignupOtpVerify<TData = SignupOtpVerifyResponseDto>(signupOtpVerifyBodyDto: SignupOtpVerifyBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerSignupOtpVerify<TData = SignupOtpVerifyResponseDto>(
    signupOtpVerifyBodyDto: SignupOtpVerifyBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/signup/otp/verify`,
      signupOtpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/signup/otp/verify`,
      signupOtpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/signup/otp/verify`,
      signupOtpVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 소셜 로그인 — 기존 계정 200, 첫 가입 시 필수 필드 누락이면 202
 */
 spinoffAuthControllerSocial<TData = IssuedSessionResponseDto | SocialPendingResponseDto>(socialBodyDto: SocialBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerSocial<TData = IssuedSessionResponseDto | SocialPendingResponseDto>(socialBodyDto: SocialBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerSocial<TData = IssuedSessionResponseDto | SocialPendingResponseDto>(socialBodyDto: SocialBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerSocial<TData = IssuedSessionResponseDto | SocialPendingResponseDto>(
    socialBodyDto: SocialBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/social`,
      socialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/social`,
      socialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/social`,
      socialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 소셜 가입 완료 — OTP 검증 후 기존 계정 연결 또는 신규 계정 생성 + 세션 발급
 */
 spinoffAuthControllerSocialComplete<TData = IssuedSessionResponseDto>(socialCompleteBodyDto: SocialCompleteBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerSocialComplete<TData = IssuedSessionResponseDto>(socialCompleteBodyDto: SocialCompleteBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerSocialComplete<TData = IssuedSessionResponseDto>(socialCompleteBodyDto: SocialCompleteBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerSocialComplete<TData = IssuedSessionResponseDto>(
    socialCompleteBodyDto: SocialCompleteBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/social/complete`,
      socialCompleteBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/social/complete`,
      socialCompleteBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/social/complete`,
      socialCompleteBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 소셜 가입 보류 — 누락 필드 OTP 발송. dry-run 모드에서는 dryRunCode 포함.
 */
 spinoffAuthControllerSocialOtpRequest<TData = SocialOtpRequestResponseDto>(socialOtpRequestBodyDto: SocialOtpRequestBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffAuthControllerSocialOtpRequest<TData = SocialOtpRequestResponseDto>(socialOtpRequestBodyDto: SocialOtpRequestBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffAuthControllerSocialOtpRequest<TData = SocialOtpRequestResponseDto>(socialOtpRequestBodyDto: SocialOtpRequestBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffAuthControllerSocialOtpRequest<TData = SocialOtpRequestResponseDto>(
    socialOtpRequestBodyDto: SocialOtpRequestBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/social/otp/request`,
      socialOtpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/social/otp/request`,
      socialOtpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/social/otp/request`,
      socialOtpRequestBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 요청한 서비스는 토큰의 client_id, 대상은 본문의 전화번호(학교종이에서 번호 인증을 마친 계정)로 서버가 정한다. 응답의 matchNumber 를 요청한 화면에만 보여 주면 사용자가 학교종이 앱의 승인 화면에서 같은 숫자를 골라 승인한다. 같은 사용자·서비스의 이전 대기 요청은 이 요청이 대체한다. 같은 requestId 로 다시 부르면 새 요청·푸시 없이 기존 요청을 돌려준다(재시도 안전). 이 번호의 학교종이 계정이 없거나 푸시를 받을 앱 기기가 없으면 둘을 구분하지 않고 422(code=NO_PUSH_DEVICE)로 답하니 다른 인증 방식으로 되돌아가야 한다.
 * @summary 전화번호의 학교종이 계정 사용자에게 앱 승인 요청 보내기(client.authenticator.request)
 */
 authenticatorRequestsControllerCreate<TData = AuthenticatorRequestCreatedDto>(createAuthenticatorRequestDto: CreateAuthenticatorRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 authenticatorRequestsControllerCreate<TData = AuthenticatorRequestCreatedDto>(createAuthenticatorRequestDto: CreateAuthenticatorRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 authenticatorRequestsControllerCreate<TData = AuthenticatorRequestCreatedDto>(createAuthenticatorRequestDto: CreateAuthenticatorRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  authenticatorRequestsControllerCreate<TData = AuthenticatorRequestCreatedDto>(
    createAuthenticatorRequestDto: CreateAuthenticatorRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/authenticator-requests`,
      createAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/authenticator-requests`,
      createAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/authenticator-requests`,
      createAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 요청을 만든 서비스만 조회할 수 있다. 결정된 결과를 처음 읽을 때 consumedAt이 한 번 기록되며, 이후 재조회도 같은 최종 상태를 돌려준다.
 * @summary 내가 만든 승인 요청의 결과 폴링(client.authenticator.request)
 */
 authenticatorRequestsControllerGetResult<TData = AuthenticatorRequestResultDto>(authenticatorRequestId: string, options?: HttpClientBodyOptions): Observable<TData>;
 authenticatorRequestsControllerGetResult<TData = AuthenticatorRequestResultDto>(authenticatorRequestId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 authenticatorRequestsControllerGetResult<TData = AuthenticatorRequestResultDto>(authenticatorRequestId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  authenticatorRequestsControllerGetResult<TData = AuthenticatorRequestResultDto>(
    authenticatorRequestId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/authenticator-requests/${authenticatorRequestId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/authenticator-requests/${authenticatorRequestId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/authenticator-requests/${authenticatorRequestId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 본인이 만든 App 목록(하위 client 포함)
 */
 developerOAuthAppControllerList<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthAppControllerList<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthAppControllerList<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthAppControllerList<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/developer/apps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/developer/apps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/developer/apps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary App 신청 — name+scope, status=Pending으로 생성
 */
 developerOAuthAppControllerCreate<TData = void>(createOAuthClientAppDto: CreateOAuthClientAppDto, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthAppControllerCreate<TData = void>(createOAuthClientAppDto: CreateOAuthClientAppDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthAppControllerCreate<TData = void>(createOAuthClientAppDto: CreateOAuthClientAppDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthAppControllerCreate<TData = void>(
    createOAuthClientAppDto: CreateOAuthClientAppDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/developer/apps`,
      createOAuthClientAppDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/developer/apps`,
      createOAuthClientAppDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/developer/apps`,
      createOAuthClientAppDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 본인 App 상세(하위 client 포함)
 */
 developerOAuthAppControllerGet<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthAppControllerGet<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthAppControllerGet<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthAppControllerGet<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/developer/apps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/developer/apps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/developer/apps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary Rejected 상태의 App 신청 내용 수정 + 재제출(status→Pending)
 */
 developerOAuthAppControllerResubmit<TData = void>(id: string,
    createOAuthClientAppDto: CreateOAuthClientAppDto, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthAppControllerResubmit<TData = void>(id: string,
    createOAuthClientAppDto: CreateOAuthClientAppDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthAppControllerResubmit<TData = void>(id: string,
    createOAuthClientAppDto: CreateOAuthClientAppDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthAppControllerResubmit<TData = void>(
    id: string,
    createOAuthClientAppDto: CreateOAuthClientAppDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/developer/apps/${id}`,
      createOAuthClientAppDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/developer/apps/${id}`,
      createOAuthClientAppDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/developer/apps/${id}`,
      createOAuthClientAppDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 심사 중(Pending)인 App 신청을 신청자 본인이 취소(status→Canceled)
 */
 developerOAuthAppControllerCancel<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthAppControllerCancel<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthAppControllerCancel<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthAppControllerCancel<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/developer/apps/${id}/cancel`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/developer/apps/${id}/cancel`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/developer/apps/${id}/cancel`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 이 App 아래 OAuth client 생성(web/device) — App이 Approved일 때만, 심사 없이 즉시 생성
 */
 developerOAuthAppControllerCreateClient<TData = void>(id: string,
    submitOAuthAppClientDto: SubmitOAuthAppClientDto, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthAppControllerCreateClient<TData = void>(id: string,
    submitOAuthAppClientDto: SubmitOAuthAppClientDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthAppControllerCreateClient<TData = void>(id: string,
    submitOAuthAppClientDto: SubmitOAuthAppClientDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthAppControllerCreateClient<TData = void>(
    id: string,
    submitOAuthAppClientDto: SubmitOAuthAppClientDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/developer/apps/${id}/oauth-clients`,
      submitOAuthAppClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/developer/apps/${id}/oauth-clients`,
      submitOAuthAppClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/developer/apps/${id}/oauth-clients`,
      submitOAuthAppClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary Approved App에 추가 scope 신청 — staff 승인 필요, App 상태 자체는 바뀌지 않음
 */
 developerOAuthAppControllerCreateScopeRequest<TData = void>(id: string,
    createOAuthClientAppScopeRequestDto: CreateOAuthClientAppScopeRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthAppControllerCreateScopeRequest<TData = void>(id: string,
    createOAuthClientAppScopeRequestDto: CreateOAuthClientAppScopeRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthAppControllerCreateScopeRequest<TData = void>(id: string,
    createOAuthClientAppScopeRequestDto: CreateOAuthClientAppScopeRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthAppControllerCreateScopeRequest<TData = void>(
    id: string,
    createOAuthClientAppScopeRequestDto: CreateOAuthClientAppScopeRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/developer/apps/${id}/scope-requests`,
      createOAuthClientAppScopeRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/developer/apps/${id}/scope-requests`,
      createOAuthClientAppScopeRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/developer/apps/${id}/scope-requests`,
      createOAuthClientAppScopeRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 본인이 만든 OAuth client 목록
 */
 developerOAuthClientControllerList<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthClientControllerList<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthClientControllerList<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthClientControllerList<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/developer/oauth-clients`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/developer/oauth-clients`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/developer/oauth-clients`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 신청 가능한 scope 목록
 */
 developerOAuthClientControllerGetAvailableScopes<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthClientControllerGetAvailableScopes<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthClientControllerGetAvailableScopes<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthClientControllerGetAvailableScopes<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/developer/oauth-clients/scopes`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/developer/oauth-clients/scopes`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/developer/oauth-clients/scopes`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 본인이 만든 OAuth client 상세
 */
 developerOAuthClientControllerGet<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthClientControllerGet<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthClientControllerGet<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthClientControllerGet<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/developer/oauth-clients/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/developer/oauth-clients/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/developer/oauth-clients/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary popup/iframe trustedEmbedOrigins 편집 — 배열 전체 교체
 */
 developerOAuthClientControllerUpdateEmbedOrigins<TData = void>(id: string,
    updateEmbedOriginsDto: UpdateEmbedOriginsDto, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthClientControllerUpdateEmbedOrigins<TData = void>(id: string,
    updateEmbedOriginsDto: UpdateEmbedOriginsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthClientControllerUpdateEmbedOrigins<TData = void>(id: string,
    updateEmbedOriginsDto: UpdateEmbedOriginsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthClientControllerUpdateEmbedOrigins<TData = void>(
    id: string,
    updateEmbedOriginsDto: UpdateEmbedOriginsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/developer/oauth-clients/${id}/embed-origins`,
      updateEmbedOriginsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/developer/oauth-clients/${id}/embed-origins`,
      updateEmbedOriginsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/developer/oauth-clients/${id}/embed-origins`,
      updateEmbedOriginsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 승인된 App 아래 client의 client_secret 생성/재발급 — 응답에만 1회 노출
 */
 developerOAuthClientControllerIssueSecret<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 developerOAuthClientControllerIssueSecret<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 developerOAuthClientControllerIssueSecret<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  developerOAuthClientControllerIssueSecret<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/developer/oauth-clients/${id}/secret`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/developer/oauth-clients/${id}/secret`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/developer/oauth-clients/${id}/secret`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 healthControllerCheck<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 healthControllerCheck<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 healthControllerCheck<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  healthControllerCheck<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/health`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/health`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/health`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 승인 화면에 보일 문맥(서비스명·요청 시각·보기) — 본인의 요청만
 */
 authenticatorRequestVerificationControllerGetContext<TData = AuthenticatorRequestContextDto>(authenticatorRequestId: string, options?: HttpClientBodyOptions): Observable<TData>;
 authenticatorRequestVerificationControllerGetContext<TData = AuthenticatorRequestContextDto>(authenticatorRequestId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 authenticatorRequestVerificationControllerGetContext<TData = AuthenticatorRequestContextDto>(authenticatorRequestId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  authenticatorRequestVerificationControllerGetContext<TData = AuthenticatorRequestContextDto>(
    authenticatorRequestId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/context`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/context`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/context`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary "내가 요청한 것이 아님"으로 거부
 */
 authenticatorRequestVerificationControllerReject<TData = void>(authenticatorRequestId: string,
    rejectAuthenticatorRequestDto: RejectAuthenticatorRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 authenticatorRequestVerificationControllerReject<TData = void>(authenticatorRequestId: string,
    rejectAuthenticatorRequestDto: RejectAuthenticatorRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 authenticatorRequestVerificationControllerReject<TData = void>(authenticatorRequestId: string,
    rejectAuthenticatorRequestDto: RejectAuthenticatorRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  authenticatorRequestVerificationControllerReject<TData = void>(
    authenticatorRequestId: string,
    rejectAuthenticatorRequestDto: RejectAuthenticatorRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/rejection`,
      rejectAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/rejection`,
      rejectAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/rejection`,
      rejectAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 여러 기기에 알림이 가므로 어느 기기에서든 처리할 수 있고, 먼저 처리한 하나만 성공한다(이미 처리됐으면 409, 만료됐으면 410).
 * @summary 요청 화면의 숫자를 골라 승인(오답이면 요청이 즉시 거부로 닫힘)
 */
 authenticatorRequestVerificationControllerVerify<TData = AuthenticatorVerificationResultDto>(authenticatorRequestId: string,
    verifyAuthenticatorRequestDto: VerifyAuthenticatorRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 authenticatorRequestVerificationControllerVerify<TData = AuthenticatorVerificationResultDto>(authenticatorRequestId: string,
    verifyAuthenticatorRequestDto: VerifyAuthenticatorRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 authenticatorRequestVerificationControllerVerify<TData = AuthenticatorVerificationResultDto>(authenticatorRequestId: string,
    verifyAuthenticatorRequestDto: VerifyAuthenticatorRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  authenticatorRequestVerificationControllerVerify<TData = AuthenticatorVerificationResultDto>(
    authenticatorRequestId: string,
    verifyAuthenticatorRequestDto: VerifyAuthenticatorRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/verification`,
      verifyAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/verification`,
      verifyAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/authenticator-requests/${authenticatorRequestId}/verification`,
      verifyAuthenticatorRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 기기의 FCM 디바이스 토큰 등록/갱신(설치 단위 upsert)
 */
 fcmDevicesControllerRegisterDevice<TData = void>(registerFcmDeviceDto: RegisterFcmDeviceDto, options?: HttpClientBodyOptions): Observable<TData>;
 fcmDevicesControllerRegisterDevice<TData = void>(registerFcmDeviceDto: RegisterFcmDeviceDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 fcmDevicesControllerRegisterDevice<TData = void>(registerFcmDeviceDto: RegisterFcmDeviceDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  fcmDevicesControllerRegisterDevice<TData = void>(
    registerFcmDeviceDto: RegisterFcmDeviceDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/me/devices`,
      registerFcmDeviceDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/me/devices`,
      registerFcmDeviceDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/me/devices`,
      registerFcmDeviceDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary FCM 알림 수신 ack — 발행 payload의 data.deliveryId를 그대로 전달
 */
 fcmDevicesControllerAckDelivery<TData = void>(deliveryId: string, options?: HttpClientBodyOptions): Observable<TData>;
 fcmDevicesControllerAckDelivery<TData = void>(deliveryId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 fcmDevicesControllerAckDelivery<TData = void>(deliveryId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  fcmDevicesControllerAckDelivery<TData = void>(
    deliveryId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/devices/deliveries/${deliveryId}/ack`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/devices/deliveries/${deliveryId}/ack`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/devices/deliveries/${deliveryId}/ack`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 초대함 — 내 phone과 같은 좌석 중 수락 대기(Pending) 목록
 */
 memberInvitationsControllerList<TData = ListMyInvitationsResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 memberInvitationsControllerList<TData = ListMyInvitationsResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberInvitationsControllerList<TData = ListMyInvitationsResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberInvitationsControllerList<TData = ListMyInvitationsResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/org-invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/org-invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/org-invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 초대 수락 — Pending→Joined (이미 수락했으면 멱등 성공)
 */
 memberInvitationsControllerAccept<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 memberInvitationsControllerAccept<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberInvitationsControllerAccept<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberInvitationsControllerAccept<TData = OrgInvitationResponseDto>(
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/org-invitations/${memberId}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/org-invitations/${memberId}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/org-invitations/${memberId}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 초대 거절 — Pending→Declined (이미 거절했으면 멱등 성공)
 */
 memberInvitationsControllerReject<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 memberInvitationsControllerReject<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberInvitationsControllerReject<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberInvitationsControllerReject<TData = OrgInvitationResponseDto>(
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/org-invitations/${memberId}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/org-invitations/${memberId}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/org-invitations/${memberId}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 탈퇴하는 좌석이 속한 그룹에 내 다른 가입 좌석이 하나도 없을 때만 그 그룹의 user_to_group을 지운다. 단체(org root) 좌석에서만 마지막 Owner 탈퇴를 막는다(LAST_ORG_OWNER). 관리자가 대신 탈퇴시키는 경로는 없다.
 * @summary 단체(또는 team) 탈퇴 — Joined→Left (이미 탈퇴했으면 멱등 성공)
 */
 myOrgMembershipsControllerLeave<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 myOrgMembershipsControllerLeave<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 myOrgMembershipsControllerLeave<TData = OrgInvitationResponseDto>(memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  myOrgMembershipsControllerLeave<TData = OrgInvitationResponseDto>(
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/org-memberships/${memberId}/leave`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/org-memberships/${memberId}/leave`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/org-memberships/${memberId}/leave`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 로그인한 사용자가 속한 단체 목록 (OAuth access token 또는 자체 로그인 세션) — 기본은 전체, adminOnly=true면 admin인 단체만
 */
 meOrgsControllerListMyOrgs<TData = MyOrgListResponseDto>(params?: MeOrgsControllerListMyOrgsParams, options?: HttpClientBodyOptions): Observable<TData>;
 meOrgsControllerListMyOrgs<TData = MyOrgListResponseDto>(params?: MeOrgsControllerListMyOrgsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 meOrgsControllerListMyOrgs<TData = MyOrgListResponseDto>(params?: MeOrgsControllerListMyOrgsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  meOrgsControllerListMyOrgs<TData = MyOrgListResponseDto>(
    params?: MeOrgsControllerListMyOrgsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/orgs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/orgs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/me/orgs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 새 단체 개설 (OAuth access token 또는 자체 로그인 세션) — 생성자가 admin으로 자동 소속
 */
 meOrgsControllerCreateOrg<TData = MyOrgDto>(createOrgDto: CreateOrgDto, options?: HttpClientBodyOptions): Observable<TData>;
 meOrgsControllerCreateOrg<TData = MyOrgDto>(createOrgDto: CreateOrgDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 meOrgsControllerCreateOrg<TData = MyOrgDto>(createOrgDto: CreateOrgDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  meOrgsControllerCreateOrg<TData = MyOrgDto>(
    createOrgDto: CreateOrgDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/orgs`,
      createOrgDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/orgs`,
      createOrgDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/orgs`,
      createOrgDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * GET /orgs/:orgId/members(admin 전용 전체 명단)와 달리 인증된 호출자라면 누구나 부를 수 있다 — 결과가 항상 호출자 본인(userId)이 이 org 트리(root+하위 team) 안에서 가진 자리로만 제한되기 때문이다(보통 1건, 여러 team의 담임/보조담임을 겸하거나 교직원이면서 자기 자녀의 보호자이기도 하면 여러 건).
 * @summary 내 자신의 단체 멤버 자리 목록 (본인 전용 — OAuth access token 또는 자체 로그인 세션, admin 가드 아님)
 */
 meOrgsControllerListMyMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 meOrgsControllerListMyMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 meOrgsControllerListMyMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  meOrgsControllerListMyMemberships<TData = ListMyOrgMembersResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/orgs/${orgId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * GET /orgs/:orgId/teams/:teamId/members(team 전체 명단, org admin/교직원 또는 이 team의 owner/admin 전용)와 달리 인증된 호출자라면 누구나 부를 수 있다 — 결과가 항상 호출자 본인(userId)이 이 teamId에 가진 자리로만 제한되기 때문이다(org 전체를 보는 GET /me/orgs/:orgId/members와 동일 원칙, teamId 필터만 추가). 이 team 소속이 아니면 빈 배열을 반환한다(403/404 아님).
 * @summary 이 팀(반)에서 내 자신의 멤버 자리 조회 (본인 전용 — OAuth access token 또는 자체 로그인 세션, admin/team 가드 아님)
 */
 meOrgsControllerListMyTeamMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 meOrgsControllerListMyTeamMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 meOrgsControllerListMyTeamMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  meOrgsControllerListMyTeamMemberships<TData = ListMyOrgMembersResponseDto>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/teams/${teamId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/teams/${teamId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/orgs/${orgId}/teams/${teamId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 번호 변경 확정 — OTP 검증 후 번호를 바꾸고 옛 번호로 수락한 좌석을 새 번호로 옮긴다(비동기)
 */
 phoneChangeControllerConfirm<TData = PhoneChangeResultDto>(confirmPhoneChangeDto: ConfirmPhoneChangeDto, options?: HttpClientBodyOptions): Observable<TData>;
 phoneChangeControllerConfirm<TData = PhoneChangeResultDto>(confirmPhoneChangeDto: ConfirmPhoneChangeDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 phoneChangeControllerConfirm<TData = PhoneChangeResultDto>(confirmPhoneChangeDto: ConfirmPhoneChangeDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  phoneChangeControllerConfirm<TData = PhoneChangeResultDto>(
    confirmPhoneChangeDto: ConfirmPhoneChangeDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/phone/change`,
      confirmPhoneChangeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/phone/change`,
      confirmPhoneChangeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/phone/change`,
      confirmPhoneChangeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 새 번호로 OTP 발송 — 번호 변경 1단계(현재 번호와 같으면 400)
 */
 phoneChangeControllerRequestOtp<TData = void>(requestPhoneChangeOtpDto: RequestPhoneChangeOtpDto, options?: HttpClientBodyOptions): Observable<TData>;
 phoneChangeControllerRequestOtp<TData = void>(requestPhoneChangeOtpDto: RequestPhoneChangeOtpDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 phoneChangeControllerRequestOtp<TData = void>(requestPhoneChangeOtpDto: RequestPhoneChangeOtpDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  phoneChangeControllerRequestOtp<TData = void>(
    requestPhoneChangeOtpDto: RequestPhoneChangeOtpDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/phone/otp`,
      requestPhoneChangeOtpDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/phone/otp`,
      requestPhoneChangeOtpDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/phone/otp`,
      requestPhoneChangeOtpDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 호출자 본인의 프로필(phone/email/name) — OAuth access token 또는 자체 로그인 세션
 */
 meProfileControllerGetProfile<TData = SelfProfileDto>( options?: HttpClientBodyOptions): Observable<TData>;
 meProfileControllerGetProfile<TData = SelfProfileDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 meProfileControllerGetProfile<TData = SelfProfileDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  meProfileControllerGetProfile<TData = SelfProfileDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/profile`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/profile`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/profile`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 알림 목록 (최신순)
 */
 spinoffNotificationsControllerList<TData = ListNotificationsResponseDto>(params?: SpinoffNotificationsControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerList<TData = ListNotificationsResponseDto>(params?: SpinoffNotificationsControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerList<TData = ListNotificationsResponseDto>(params?: SpinoffNotificationsControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerList<TData = ListNotificationsResponseDto>(
    params?: SpinoffNotificationsControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/notifications`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/notifications`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/notifications`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 알림 열음 보고 — 멱등, 받음 보고가 없었어도 받음으로 간주해 함께 기록. 없거나 남의 것이면 404
 */
 spinoffNotificationsControllerReportOpened<TData = void>(deliveryId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerReportOpened<TData = void>(deliveryId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerReportOpened<TData = void>(deliveryId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerReportOpened<TData = void>(
    deliveryId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/opened`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/opened`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/opened`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 알림 수신(받음) 보고 — 멱등. 없거나 남의 것이면 404, 이미 처리됐거나 실패·건너뜀으로 확정된 발송이면 그대로 성공
 */
 spinoffNotificationsControllerReportReceived<TData = void>(deliveryId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerReportReceived<TData = void>(deliveryId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerReportReceived<TData = void>(deliveryId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerReportReceived<TData = void>(
    deliveryId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/received`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/received`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/received`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 알림 받음/열음 보고 (메시지별 토큰, 인증 헤더 없음) — 멱등. 토큰이 유효하면 항상 204, 서명·만료·형식 오류는 사유와 무관하게 401
 */
 spinoffNotificationDeliveryReportControllerReport<TData = void>(deliveryReportByTokenBodyDto: DeliveryReportByTokenBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationDeliveryReportControllerReport<TData = void>(deliveryReportByTokenBodyDto: DeliveryReportByTokenBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationDeliveryReportControllerReport<TData = void>(deliveryReportByTokenBodyDto: DeliveryReportByTokenBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationDeliveryReportControllerReport<TData = void>(
    deliveryReportByTokenBodyDto: DeliveryReportByTokenBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/delivery-reports`,
      deliveryReportByTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/delivery-reports`,
      deliveryReportByTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/delivery-reports`,
      deliveryReportByTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 안읽음 알림 전체 읽음 처리
 */
 spinoffNotificationsControllerMarkAllRead<TData = MarkAllNotificationsReadResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerMarkAllRead<TData = MarkAllNotificationsReadResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerMarkAllRead<TData = MarkAllNotificationsReadResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerMarkAllRead<TData = MarkAllNotificationsReadResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/read-all`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/read-all`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/read-all`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 안읽음 알림 개수
 */
 spinoffNotificationsControllerUnreadCount<TData = UnreadCountResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerUnreadCount<TData = UnreadCountResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerUnreadCount<TData = UnreadCountResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerUnreadCount<TData = UnreadCountResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/notifications/unread-count`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/notifications/unread-count`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/notifications/unread-count`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 알림 1건 읽음 처리 (멱등 — 이미 읽었으면 그대로 성공, 남의 알림이면 404)
 */
 spinoffNotificationsControllerMarkRead<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerMarkRead<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerMarkRead<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerMarkRead<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/${id}/read`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/${id}/read`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/${id}/read`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (RS 백엔드용) 토큰의 client_id로 자기 자신의 trustedEmbedOrigins만 조회
 */
 oAuthClientMeControllerGetEmbedOrigins<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 oAuthClientMeControllerGetEmbedOrigins<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oAuthClientMeControllerGetEmbedOrigins<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oAuthClientMeControllerGetEmbedOrigins<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/oauth/clients/me/embed-origins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/oauth/clients/me/embed-origins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/oauth/clients/me/embed-origins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 현재 사용자의 active consent 목록
 */
 oAuthConsentManageControllerListConsents<TData = OAuthConsentListResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 oAuthConsentManageControllerListConsents<TData = OAuthConsentListResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oAuthConsentManageControllerListConsents<TData = OAuthConsentListResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oAuthConsentManageControllerListConsents<TData = OAuthConsentListResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/oauth/consents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/oauth/consents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/oauth/consents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary Consent 철회 (revoke)
 */
 oAuthConsentManageControllerRevokeConsent<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 oAuthConsentManageControllerRevokeConsent<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oAuthConsentManageControllerRevokeConsent<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oAuthConsentManageControllerRevokeConsent<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/oauth/consents/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/oauth/consents/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/oauth/consents/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary Interaction 진입점 — SPA /oauth/authorize?interaction=<uid> 로 리다이렉트
 */
 oidcInteractionControllerInteractionRedirect<TData = void>(uid: string, options?: HttpClientBodyOptions): Observable<TData>;
 oidcInteractionControllerInteractionRedirect<TData = void>(uid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oidcInteractionControllerInteractionRedirect<TData = void>(uid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oidcInteractionControllerInteractionRedirect<TData = void>(
    uid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/oauth/interaction/${uid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/oauth/interaction/${uid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/oauth/interaction/${uid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (Web UI용) 동의 거부
 */
 oidcInteractionControllerInteractionDeny<TData = InteractionRedirectDto>(uid: string, options?: HttpClientBodyOptions): Observable<TData>;
 oidcInteractionControllerInteractionDeny<TData = InteractionRedirectDto>(uid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oidcInteractionControllerInteractionDeny<TData = InteractionRedirectDto>(uid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oidcInteractionControllerInteractionDeny<TData = InteractionRedirectDto>(
    uid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/interaction/${uid}/deny`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/interaction/${uid}/deny`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/interaction/${uid}/deny`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (Web UI용) Interaction 상세 정보 반환
 */
 oidcInteractionControllerInteractionDetails<TData = InteractionDetailsDto>(uid: string, options?: HttpClientBodyOptions): Observable<TData>;
 oidcInteractionControllerInteractionDetails<TData = InteractionDetailsDto>(uid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oidcInteractionControllerInteractionDetails<TData = InteractionDetailsDto>(uid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oidcInteractionControllerInteractionDetails<TData = InteractionDetailsDto>(
    uid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/oauth/interaction/${uid}/details`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/oauth/interaction/${uid}/details`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/oauth/interaction/${uid}/details`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (Web UI용) 동의 완료 — oauth_consents upsert + interactionResult
 */
 oidcInteractionControllerInteractionLogin<TData = InteractionRedirectDto>(uid: string,
    loginBodyDto: LoginBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 oidcInteractionControllerInteractionLogin<TData = InteractionRedirectDto>(uid: string,
    loginBodyDto: LoginBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oidcInteractionControllerInteractionLogin<TData = InteractionRedirectDto>(uid: string,
    loginBodyDto: LoginBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oidcInteractionControllerInteractionLogin<TData = InteractionRedirectDto>(
    uid: string,
    loginBodyDto: LoginBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/interaction/${uid}/login`,
      loginBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/interaction/${uid}/login`,
      loginBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/interaction/${uid}/login`,
      loginBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (staff-web용) Staff 세션으로 interaction 완료 — org/team 소속 검증·동의 화면 없이 즉시 로그인 처리
 */
 oidcInteractionControllerInteractionStaffLogin<TData = void>(uid: string, options?: HttpClientBodyOptions): Observable<TData>;
 oidcInteractionControllerInteractionStaffLogin<TData = void>(uid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oidcInteractionControllerInteractionStaffLogin<TData = void>(uid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oidcInteractionControllerInteractionStaffLogin<TData = void>(
    uid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/interaction/${uid}/staff-login`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/interaction/${uid}/staff-login`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/interaction/${uid}/staff-login`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (RP 백엔드용) 멤버 피커 세션 생성 — org access token(Bearer)
 */
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>( options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/member-picker/sessions`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (팝업용, 무인증) 세션의 org 멤버·팀 목록 + postMessage 대상 origin 조회
 */
 memberPickerControllerGetSessionContext<TData = MemberPickerSessionContextDto>(code: string, options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerGetSessionContext<TData = MemberPickerSessionContextDto>(code: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerGetSessionContext<TData = MemberPickerSessionContextDto>(code: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerGetSessionContext<TData = MemberPickerSessionContextDto>(
    code: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/oauth/member-picker/sessions/${code}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/oauth/member-picker/sessions/${code}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/oauth/member-picker/sessions/${code}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (팝업용, 무인증) 선택 확정 — teamIds/labelIds 해소해 스냅샷 저장
 */
 memberPickerControllerConfirmSession<TData = void>(code: string,
    confirmMemberPickerSessionDto: ConfirmMemberPickerSessionDto, options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerConfirmSession<TData = void>(code: string,
    confirmMemberPickerSessionDto: ConfirmMemberPickerSessionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerConfirmSession<TData = void>(code: string,
    confirmMemberPickerSessionDto: ConfirmMemberPickerSessionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerConfirmSession<TData = void>(
    code: string,
    confirmMemberPickerSessionDto: ConfirmMemberPickerSessionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/confirm`,
      confirmMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/confirm`,
      confirmMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/confirm`,
      confirmMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (RP 백엔드용) 확정된 선택 결과를 client_secret으로 최종 교환(1회 소비)
 */
 memberPickerControllerExchangeSession<TData = MemberPickerSelectionResultDto>(code: string,
    exchangeMemberPickerSessionDto: ExchangeMemberPickerSessionDto, options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerExchangeSession<TData = MemberPickerSelectionResultDto>(code: string,
    exchangeMemberPickerSessionDto: ExchangeMemberPickerSessionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerExchangeSession<TData = MemberPickerSelectionResultDto>(code: string,
    exchangeMemberPickerSessionDto: ExchangeMemberPickerSessionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerExchangeSession<TData = MemberPickerSelectionResultDto>(
    code: string,
    exchangeMemberPickerSessionDto: ExchangeMemberPickerSessionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/exchange`,
      exchangeMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/exchange`,
      exchangeMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/exchange`,
      exchangeMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (Web UI용) 서비스 연결 해지
 */
 oAuthServiceConnectionControllerDisconnect<TData = void>(disconnectServiceBodyDto: DisconnectServiceBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 oAuthServiceConnectionControllerDisconnect<TData = void>(disconnectServiceBodyDto: DisconnectServiceBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oAuthServiceConnectionControllerDisconnect<TData = void>(disconnectServiceBodyDto: DisconnectServiceBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oAuthServiceConnectionControllerDisconnect<TData = void>(
    disconnectServiceBodyDto: DisconnectServiceBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/oauth/service-connections`,{body: disconnectServiceBodyDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/oauth/service-connections`,{body: disconnectServiceBodyDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }}
    );
    }

    return this.http.delete<TData>(
      `/oauth/service-connections`,{body: disconnectServiceBodyDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }}
    );
  }

/**
 * @summary (Web UI용) 연결 가능한 외부 서비스 목록 + 연결 상태
 */
 oAuthServiceConnectionControllerListConnectableServices<TData = ConnectableServiceDto[]>(params: OAuthServiceConnectionControllerListConnectableServicesParams, options?: HttpClientBodyOptions): Observable<TData>;
 oAuthServiceConnectionControllerListConnectableServices<TData = ConnectableServiceDto[]>(params: OAuthServiceConnectionControllerListConnectableServicesParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oAuthServiceConnectionControllerListConnectableServices<TData = ConnectableServiceDto[]>(params: OAuthServiceConnectionControllerListConnectableServicesParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oAuthServiceConnectionControllerListConnectableServices<TData = ConnectableServiceDto[]>(
    params: OAuthServiceConnectionControllerListConnectableServicesParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/oauth/service-connections`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/oauth/service-connections`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/oauth/service-connections`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary (Web UI용) 서비스 연결 — consent 생성(+ redirectUri 명시 시 authorization_code 발급)
 */
 oAuthServiceConnectionControllerConnect<TData = ConnectServiceResponseDto>(connectServiceBodyDto: ConnectServiceBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 oAuthServiceConnectionControllerConnect<TData = ConnectServiceResponseDto>(connectServiceBodyDto: ConnectServiceBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 oAuthServiceConnectionControllerConnect<TData = ConnectServiceResponseDto>(connectServiceBodyDto: ConnectServiceBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  oAuthServiceConnectionControllerConnect<TData = ConnectServiceResponseDto>(
    connectServiceBodyDto: ConnectServiceBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/service-connections`,
      connectServiceBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/service-connections`,
      connectServiceBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/service-connections`,
      connectServiceBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 서비스 입장(magic-link 핸드오프) — 노출·자격 판정 후 user/org 토큰 mint + redirect
 */
 magicLinkEntryControllerConnectViaMagicLink<TData = MagicLinkEntryResponseDto>(connectViaMagicLinkBodyDto: ConnectViaMagicLinkBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 magicLinkEntryControllerConnectViaMagicLink<TData = MagicLinkEntryResponseDto>(connectViaMagicLinkBodyDto: ConnectViaMagicLinkBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 magicLinkEntryControllerConnectViaMagicLink<TData = MagicLinkEntryResponseDto>(connectViaMagicLinkBodyDto: ConnectViaMagicLinkBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  magicLinkEntryControllerConnectViaMagicLink<TData = MagicLinkEntryResponseDto>(
    connectViaMagicLinkBodyDto: ConnectViaMagicLinkBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/service-connections/magic-link`,
      connectViaMagicLinkBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/service-connections/magic-link`,
      connectViaMagicLinkBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/service-connections/magic-link`,
      connectViaMagicLinkBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 생성 때 고를 수 있는 지역 선택 tree
 */
 orgRegionsControllerListOrgRegions<TData = OrgRegionListResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 orgRegionsControllerListOrgRegions<TData = OrgRegionListResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgRegionsControllerListOrgRegions<TData = OrgRegionListResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgRegionsControllerListOrgRegions<TData = OrgRegionListResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/org-regions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/org-regions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/org-regions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 상세 조회 (OAuth access token 또는 자체 로그인 세션)
 */
 orgsControllerGetOrg<TData = OrgDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgsControllerGetOrg<TData = OrgDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgsControllerGetOrg<TData = OrgDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgsControllerGetOrg<TData = OrgDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 생략한 필드는 유지하고 null은 상속으로 되돌린다. applyToTeams=overwrite면 요청 필드를 모든 자손에서 되돌린다.
 * @summary 단체 단위 서비스 설정 쓰기
 */
 appLayerSettingControllerPutOrgSetting<TData = void>(orgId: string,
    appId: string,
    putAppLayerSettingDto: PutAppLayerSettingDto, options?: HttpClientBodyOptions): Observable<TData>;
 appLayerSettingControllerPutOrgSetting<TData = void>(orgId: string,
    appId: string,
    putAppLayerSettingDto: PutAppLayerSettingDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 appLayerSettingControllerPutOrgSetting<TData = void>(orgId: string,
    appId: string,
    putAppLayerSettingDto: PutAppLayerSettingDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  appLayerSettingControllerPutOrgSetting<TData = void>(
    orgId: string,
    appId: string,
    putAppLayerSettingDto: PutAppLayerSettingDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/orgs/${orgId}/apps/${appId}/setting`,
      putAppLayerSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/orgs/${orgId}/apps/${appId}/setting`,
      putAppLayerSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/orgs/${orgId}/apps/${appId}/setting`,
      putAppLayerSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 서비스 사용 결정 상태 — 사용 여부·변경 가능 여부·위임될 scope·순서·팀 위임
 */
 serviceUsageControllerGet<TData = ServiceUsageDto>(orgId: string,
    appId: string, options?: HttpClientBodyOptions): Observable<TData>;
 serviceUsageControllerGet<TData = ServiceUsageDto>(orgId: string,
    appId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 serviceUsageControllerGet<TData = ServiceUsageDto>(orgId: string,
    appId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  serviceUsageControllerGet<TData = ServiceUsageDto>(
    orgId: string,
    appId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/apps/${appId}/usage`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/apps/${appId}/usage`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/apps/${appId}/usage`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 켤 때는 화면이 보여 준 위임 scope 목록을 acknowledgedScopes로 보내야 하며 현재 목록과 다르면 409(SCOPES_CHANGED). 회사 노출 서비스를 끄면 단체 행을 숨기고 CompanyExposure grant를 철회한다. 해제할 수 없는 서비스는 403.
 * @summary 서비스 사용 여부 변경(켜기·끄기)
 */
 serviceUsageControllerSet<TData = ServiceUsageDto>(orgId: string,
    appId: string,
    putServiceUsageDto: PutServiceUsageDto, options?: HttpClientBodyOptions): Observable<TData>;
 serviceUsageControllerSet<TData = ServiceUsageDto>(orgId: string,
    appId: string,
    putServiceUsageDto: PutServiceUsageDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 serviceUsageControllerSet<TData = ServiceUsageDto>(orgId: string,
    appId: string,
    putServiceUsageDto: PutServiceUsageDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  serviceUsageControllerSet<TData = ServiceUsageDto>(
    orgId: string,
    appId: string,
    putServiceUsageDto: PutServiceUsageDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/orgs/${orgId}/apps/${appId}/usage`,
      putServiceUsageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/orgs/${orgId}/apps/${appId}/usage`,
      putServiceUsageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/orgs/${orgId}/apps/${appId}/usage`,
      putServiceUsageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 누가(actor)·언제(createdAt)·무엇을(action) 바꿨는지 최신순으로 반환한다. actor의 실명은 이 응답에 없다 — userId가 있으면 GET /orgs/:orgId/members 응답에서 같은 userId를 찾아 화면에서 매핑한다(별도 조인 없음). offset 페이지네이션(10001 cap, conventions-pagination.md Mode A) — page/size로 넘긴다.
 * @summary 단체 팀/admin 변경 감사 로그 (org admin 전용, OAuth access token 또는 자체 로그인 세션)
 */
 orgAuditLogControllerListAuditLog<TData = OrgAuditLogListResponseDto>(orgId: string,
    params?: OrgAuditLogControllerListAuditLogParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgAuditLogControllerListAuditLog<TData = OrgAuditLogListResponseDto>(orgId: string,
    params?: OrgAuditLogControllerListAuditLogParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgAuditLogControllerListAuditLog<TData = OrgAuditLogListResponseDto>(orgId: string,
    params?: OrgAuditLogControllerListAuditLogParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgAuditLogControllerListAuditLog<TData = OrgAuditLogListResponseDto>(
    orgId: string,
    params?: OrgAuditLogControllerListAuditLogParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/audit-log`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/audit-log`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/audit-log`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 커스텀 라벨 삭제 상태 조회 — 요청한 id 중 살아 있지 않은 것만 restorable/gone 으로 반환 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만)
 */
 deletedTargetsControllerListDeletedLabels<TData = DeletedTargetListResponseDto>(orgId: string,
    params: DeletedTargetsControllerListDeletedLabelsParams, options?: HttpClientBodyOptions): Observable<TData>;
 deletedTargetsControllerListDeletedLabels<TData = DeletedTargetListResponseDto>(orgId: string,
    params: DeletedTargetsControllerListDeletedLabelsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deletedTargetsControllerListDeletedLabels<TData = DeletedTargetListResponseDto>(orgId: string,
    params: DeletedTargetsControllerListDeletedLabelsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deletedTargetsControllerListDeletedLabels<TData = DeletedTargetListResponseDto>(
    orgId: string,
    params: DeletedTargetsControllerListDeletedLabelsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/deleted-member-labels`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/deleted-member-labels`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/deleted-member-labels`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 멤버(자리) 삭제 상태 조회 — 요청한 id 중 살아 있지 않은 것만 restorable/gone 으로 반환 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만)
 */
 deletedTargetsControllerListDeletedMembers<TData = DeletedTargetListResponseDto>(orgId: string,
    params: DeletedTargetsControllerListDeletedMembersParams, options?: HttpClientBodyOptions): Observable<TData>;
 deletedTargetsControllerListDeletedMembers<TData = DeletedTargetListResponseDto>(orgId: string,
    params: DeletedTargetsControllerListDeletedMembersParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deletedTargetsControllerListDeletedMembers<TData = DeletedTargetListResponseDto>(orgId: string,
    params: DeletedTargetsControllerListDeletedMembersParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deletedTargetsControllerListDeletedMembers<TData = DeletedTargetListResponseDto>(
    orgId: string,
    params: DeletedTargetsControllerListDeletedMembersParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/deleted-members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/deleted-members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/deleted-members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * `daysWaiting`은 pending 좌석이 초대된 뒤 지난 일수로, 저장하지 않고 조회 시점에 계산한다. 좌석이 10000건을 넘으면 `truncated`.
 * @summary 초대 현황 — 미응답(pending)·거절(declined) 좌석을 오래 기다린 순으로 (org admin 세션 또는 org.members.read OAuth)
 */
 orgInvitationsAdminControllerList<TData = ListOrgInvitationsResponseDto>(orgId: string,
    params?: OrgInvitationsAdminControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgInvitationsAdminControllerList<TData = ListOrgInvitationsResponseDto>(orgId: string,
    params?: OrgInvitationsAdminControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgInvitationsAdminControllerList<TData = ListOrgInvitationsResponseDto>(orgId: string,
    params?: OrgInvitationsAdminControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgInvitationsAdminControllerList<TData = ListOrgInvitationsResponseDto>(
    orgId: string,
    params?: OrgInvitationsAdminControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/invitations`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/invitations`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/invitations`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * 초대 전(상태 없음)·거절(Declined)·탈퇴(Left) 좌석이 대상이다 — Pending(이미 초대 중)·Joined(이미 가입)는 409 REINVITE_NOT_ALLOWED + reason. 마지막 초대 후 24시간 쿨다운(409 REINVITE_COOLDOWN, availableAt). 초대받을 계정이 없거나 이미 단체 소속이면 거부한다. 성공하면 트랜잭션 커밋 뒤에 초대 푸시를 백그라운드로 요청한다(실패해도 응답에 영향 없음). 관리자가 대신 수락·탈퇴시키는 경로는 없다.
 * @summary 초대 전·거절·탈퇴한 좌석 (재)초대 — Pending 으로 올리고 v5 앱 초대함에도 올린다 (org admin 세션 또는 org.members.admin OAuth)
 */
 orgInvitationsAdminControllerReinvite<TData = ReinviteResultDto>(orgId: string,
    memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgInvitationsAdminControllerReinvite<TData = ReinviteResultDto>(orgId: string,
    memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgInvitationsAdminControllerReinvite<TData = ReinviteResultDto>(orgId: string,
    memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgInvitationsAdminControllerReinvite<TData = ReinviteResultDto>(
    orgId: string,
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/invitations/${memberId}/reinvite`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/invitations/${memberId}/reinvite`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/invitations/${memberId}/reinvite`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 한 명을 만들고 만들어진 멤버 자리와 로그인 코드를 돌려준다(일괄 생성 `managed-users/batch` 에 1건을 넘기는 것과 같은 검증·트랜잭션이다). 초대·수락 없이 즉시 활성이며 좌석 유형은 Student 로 고정이다. 응답의 `login.code`는 **이 응답에서 한 번만** 볼 수 있으므로(서버는 해시만 저장) 호출한 화면이 바로 인쇄·저장하게 해야 한다. 별도 삭제 API는 없다 — 자리를 제거하거나 팀을 삭제하거나 단체를 해산하면 계정도 함께 삭제된다.
 * @summary 단체 소유 멤버 단건 생성 (전화번호·이메일 없이 로그인 코드로만 로그인하는 빈 계정 + 멤버 자리, org admin 세션)
 */
 orgManagedUsersControllerCreate<TData = CreatedManagedUserDto>(orgId: string,
    createManagedUserBodyDto: CreateManagedUserBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgManagedUsersControllerCreate<TData = CreatedManagedUserDto>(orgId: string,
    createManagedUserBodyDto: CreateManagedUserBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgManagedUsersControllerCreate<TData = CreatedManagedUserDto>(orgId: string,
    createManagedUserBodyDto: CreateManagedUserBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgManagedUsersControllerCreate<TData = CreatedManagedUserDto>(
    orgId: string,
    createManagedUserBodyDto: CreateManagedUserBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/managed-users`,
      createManagedUserBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/managed-users`,
      createManagedUserBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/managed-users`,
      createManagedUserBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이름 목록으로 소유 계정을 한꺼번에 만든다(한 명도 1건짜리로 만든다). 한 요청이 한 트랜잭션이라 전부 만들어지거나 하나도 만들어지지 않는다(실패 후 재시도가 중복을 만들지 않는다). 초대·수락 없이 즉시 활성이며 좌석 유형은 Student 로 고정이다. 응답의 각 `login.code`는 **이 응답에서 한 번만** 볼 수 있으므로(서버는 해시만 저장) 호출한 화면이 바로 인쇄·저장하게 해야 한다. 소유 계정에는 전화번호·이메일·소셜 로그인·비밀번호를 붙일 수 없다. 별도 삭제 API는 없다 — 자리를 제거하거나 팀을 삭제하거나 단체를 해산하면 계정도 함께 삭제된다. 200명을 넘는 인원은 호출 측이 200명씩 나눠 순서대로 보낸다(일괄 쓰기 한도).
 * @summary 단체 소유 멤버 일괄 생성 (전화번호·이메일 없이 로그인 코드로만 로그인하는 빈 계정 + 멤버 자리, 요청당 최대 200명, org admin 세션)
 */
 orgManagedUsersControllerBatchManagedUsers<TData = BatchManagedUsersResultDto>(orgId: string,
    batchManagedUsersBodyDto: BatchManagedUsersBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgManagedUsersControllerBatchManagedUsers<TData = BatchManagedUsersResultDto>(orgId: string,
    batchManagedUsersBodyDto: BatchManagedUsersBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgManagedUsersControllerBatchManagedUsers<TData = BatchManagedUsersResultDto>(orgId: string,
    batchManagedUsersBodyDto: BatchManagedUsersBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgManagedUsersControllerBatchManagedUsers<TData = BatchManagedUsersResultDto>(
    orgId: string,
    batchManagedUsersBodyDto: BatchManagedUsersBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/managed-users/batch`,
      batchManagedUsersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/managed-users/batch`,
      batchManagedUsersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/managed-users/batch`,
      batchManagedUsersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 커스텀 라벨 카탈로그 조회 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만)
 */
 orgMemberLabelsControllerList<TData = OrgMemberLabelListResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgMemberLabelsControllerList<TData = OrgMemberLabelListResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMemberLabelsControllerList<TData = OrgMemberLabelListResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMemberLabelsControllerList<TData = OrgMemberLabelListResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/member-labels`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/member-labels`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/member-labels`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 생성 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만)
 */
 orgMemberLabelsControllerCreate<TData = OrgMemberLabelDto>(orgId: string,
    createOrgMemberLabelDto: CreateOrgMemberLabelDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMemberLabelsControllerCreate<TData = OrgMemberLabelDto>(orgId: string,
    createOrgMemberLabelDto: CreateOrgMemberLabelDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMemberLabelsControllerCreate<TData = OrgMemberLabelDto>(orgId: string,
    createOrgMemberLabelDto: CreateOrgMemberLabelDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMemberLabelsControllerCreate<TData = OrgMemberLabelDto>(
    orgId: string,
    createOrgMemberLabelDto: CreateOrgMemberLabelDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels`,
      createOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels`,
      createOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/member-labels`,
      createOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 삭제 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만) — 배정·권한도 함께 삭제된다. OAuth RP는 본인이 만든 라벨만 가능(org.member-labels.admin이면 타 App 라벨도 가능)
 */
 orgMemberLabelsControllerRemove<TData = void>(orgId: string,
    labelId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgMemberLabelsControllerRemove<TData = void>(orgId: string,
    labelId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMemberLabelsControllerRemove<TData = void>(orgId: string,
    labelId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMemberLabelsControllerRemove<TData = void>(
    orgId: string,
    labelId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 이름 변경 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만) — OAuth RP는 본인이 만든 라벨만 가능(org.member-labels.admin이면 타 App 라벨도 가능)
 */
 orgMemberLabelsControllerRename<TData = OrgMemberLabelDto>(orgId: string,
    labelId: string,
    updateOrgMemberLabelDto: UpdateOrgMemberLabelDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMemberLabelsControllerRename<TData = OrgMemberLabelDto>(orgId: string,
    labelId: string,
    updateOrgMemberLabelDto: UpdateOrgMemberLabelDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMemberLabelsControllerRename<TData = OrgMemberLabelDto>(orgId: string,
    labelId: string,
    updateOrgMemberLabelDto: UpdateOrgMemberLabelDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMemberLabelsControllerRename<TData = OrgMemberLabelDto>(
    orgId: string,
    labelId: string,
    updateOrgMemberLabelDto: UpdateOrgMemberLabelDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,
      updateOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,
      updateOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,
      updateOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨을 특정 멤버 row에 배정 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만) — targetId는 group_members row id. OAuth RP는 본인이 만든 라벨만 가능(org.member-labels.admin이면 타 App 라벨도 가능)
 */
 orgMemberLabelsControllerAssign<TData = void>(orgId: string,
    labelId: string,
    assignOrgMemberLabelDto: AssignOrgMemberLabelDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMemberLabelsControllerAssign<TData = void>(orgId: string,
    labelId: string,
    assignOrgMemberLabelDto: AssignOrgMemberLabelDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMemberLabelsControllerAssign<TData = void>(orgId: string,
    labelId: string,
    assignOrgMemberLabelDto: AssignOrgMemberLabelDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMemberLabelsControllerAssign<TData = void>(
    orgId: string,
    labelId: string,
    assignOrgMemberLabelDto: AssignOrgMemberLabelDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments`,
      assignOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments`,
      assignOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments`,
      assignOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 배정을 배치로 추가/해제 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만) — 배치당 audit log 1건. OAuth RP는 본인이 만든 라벨만 가능(org.member-labels.admin이면 타 App 라벨도 가능)
 */
 orgMemberLabelsControllerBatchUpdateAssignments<TData = void>(orgId: string,
    labelId: string,
    batchUpdateOrgMemberLabelAssignmentsDto: BatchUpdateOrgMemberLabelAssignmentsDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMemberLabelsControllerBatchUpdateAssignments<TData = void>(orgId: string,
    labelId: string,
    batchUpdateOrgMemberLabelAssignmentsDto: BatchUpdateOrgMemberLabelAssignmentsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMemberLabelsControllerBatchUpdateAssignments<TData = void>(orgId: string,
    labelId: string,
    batchUpdateOrgMemberLabelAssignmentsDto: BatchUpdateOrgMemberLabelAssignmentsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMemberLabelsControllerBatchUpdateAssignments<TData = void>(
    orgId: string,
    labelId: string,
    batchUpdateOrgMemberLabelAssignmentsDto: BatchUpdateOrgMemberLabelAssignmentsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/batch`,
      batchUpdateOrgMemberLabelAssignmentsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/batch`,
      batchUpdateOrgMemberLabelAssignmentsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/batch`,
      batchUpdateOrgMemberLabelAssignmentsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 배정 해제 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만) — targetId는 group_members row id. OAuth RP는 본인이 만든 라벨만 가능(org.member-labels.admin이면 타 App 라벨도 가능)
 */
 orgMemberLabelsControllerUnassign<TData = void>(orgId: string,
    labelId: string,
    targetId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgMemberLabelsControllerUnassign<TData = void>(orgId: string,
    labelId: string,
    targetId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMemberLabelsControllerUnassign<TData = void>(orgId: string,
    labelId: string,
    targetId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMemberLabelsControllerUnassign<TData = void>(
    orgId: string,
    labelId: string,
    targetId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/${targetId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/${targetId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/${targetId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 구성원 목록 조회 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만)
 */
 orgMembersControllerListMembers<TData = OrgMemberListResponseDto>(orgId: string,
    params?: OrgMembersControllerListMembersParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgMembersControllerListMembers<TData = OrgMemberListResponseDto>(orgId: string,
    params?: OrgMembersControllerListMembersParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMembersControllerListMembers<TData = OrgMemberListResponseDto>(orgId: string,
    params?: OrgMembersControllerListMembersParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMembersControllerListMembers<TData = OrgMemberListResponseDto>(
    orgId: string,
    params?: OrgMembersControllerListMembersParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * POST /orgs/:orgId/members/batch의 `type: "create"` 오퍼레이션을 항목 하나로 감싼 편의 엔드포인트다 — 동작·검증 규칙은 그쪽과 완전히 동일하다(멱등 생성: 같은 (App, idempotencyKey)로 재시도하면 새 멤버를 또 만들지 않고 기존 멤버를 그대로 반환한다. idempotencyKey는 OAuth RP 호출에서만 쓸 수 있고, externalRefKey는 유일하지 않은 참조 값이라 멱등이 아니다. sameAsMemberId를 주면 그 멤버의 continuity를 이어받고, 생략하면 새 연속성을 만든다. teamId를 주면 이 org 소속 team인지 확인한다 — 아니면 404. 자세한 규칙은 org-members.service.ts#batchWriteMembers, #createMemberCore 참고). spinoff-platform의 같은 라우트와 달리 **초대(invitation)/수락 대기(Pending) 단계가 없다** — email/phone으로 초대를 보내고 유저 매칭 시 자동 수락되는 흐름 대신, 이 엔드포인트는 곧바로 활성 멤버 row를 만든다(status=Uninvited). schoolbell-e에 초대 개념 자체가 없어서 생기는 구조적 차이다.
 * @summary 단체 구성원 단건 생성 (org admin 세션 또는 org.members.admin OAuth)
 */
 orgMembersControllerAddMember<TData = OrgMemberDto>(orgId: string,
    addMemberDto: AddMemberDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMembersControllerAddMember<TData = OrgMemberDto>(orgId: string,
    addMemberDto: AddMemberDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMembersControllerAddMember<TData = OrgMemberDto>(orgId: string,
    addMemberDto: AddMemberDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMembersControllerAddMember<TData = OrgMemberDto>(
    orgId: string,
    addMemberDto: AddMemberDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members`,
      addMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members`,
      addMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/members`,
      addMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 항목마다 updateMember(role/name/phone/contacts)와 reorderMembers(memberNum) 중 하나 이상을 담는다 — 한 항목이 둘 다 가질 수도 있다(같은 멤버를 필드 수정도 하고 드래그도 한 뒤 한 번에 저장하는 경우). 위치 재배정 대상은 서로 다른 team(또는 memberType)이 섞여도 되며, 서버가 (groupId, memberType) 그룹별로 나눠 독립적으로 처리한다. 배치 전체가 하나의 트랜잭션 — 항목 하나라도 실패하면 전체가 롤백된다(all-or-nothing). 자세한 검증 규칙은 batch-members.dto.ts, org-members.service.ts#batchWriteMembers 문서 참고.
 * @summary 단체 구성원 일괄 갱신 (필드 patch + 순서 재배정 통합 배치, 하나의 트랜잭션으로 원자 처리, org admin 세션 또는 org.members.admin OAuth)
 */
 orgMembersControllerBatchWriteMembers<TData = OrgMemberListResponseDto>(orgId: string,
    batchMembersBodyDto: BatchMembersBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMembersControllerBatchWriteMembers<TData = OrgMemberListResponseDto>(orgId: string,
    batchMembersBodyDto: BatchMembersBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMembersControllerBatchWriteMembers<TData = OrgMemberListResponseDto>(orgId: string,
    batchMembersBodyDto: BatchMembersBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMembersControllerBatchWriteMembers<TData = OrgMemberListResponseDto>(
    orgId: string,
    batchMembersBodyDto: BatchMembersBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/batch`,
      batchMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/batch`,
      batchMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/members/batch`,
      batchMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 같은 team(또는 org 직속)·같은 memberType 형제 집합 안에서, 호출자가 이미 계산한 최종 (id, memberNum) 값만 담아 보낸다 — 형제 전체의 순열이 아니다(보통 1건, 드물게 몇 건). 다른 team/memberType의 id를 섞거나 id·memberNum이 중복이면 400이다 (set-member-positions.dto.ts, org-members.service.ts#setMemberPositions 문서 참고). 응답은 이번 호출로 memberNum이 바뀐 멤버만의 최신 DTO다.
 * @summary 단체 구성원 순서 재배정 (드래그 정렬 결과 반영, org admin 세션 또는 org.members.admin OAuth)
 */
 orgMembersControllerReorderMembers<TData = OrgMemberListResponseDto>(orgId: string,
    setMemberPositionsDto: SetMemberPositionsDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMembersControllerReorderMembers<TData = OrgMemberListResponseDto>(orgId: string,
    setMemberPositionsDto: SetMemberPositionsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMembersControllerReorderMembers<TData = OrgMemberListResponseDto>(orgId: string,
    setMemberPositionsDto: SetMemberPositionsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMembersControllerReorderMembers<TData = OrgMemberListResponseDto>(
    orgId: string,
    setMemberPositionsDto: SetMemberPositionsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/reorder`,
      setMemberPositionsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/reorder`,
      setMemberPositionsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/members/reorder`,
      setMemberPositionsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 구성원 삭제 (org admin 세션 또는 org.members.admin OAuth)
 */
 orgMembersControllerDeleteMember<TData = void>(orgId: string,
    memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgMembersControllerDeleteMember<TData = void>(orgId: string,
    memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMembersControllerDeleteMember<TData = void>(orgId: string,
    memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMembersControllerDeleteMember<TData = void>(
    orgId: string,
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 옛 전용 서브리소스(POST/DELETE /orgs/:orgId/admins)를 대체한다(2026-08-19, org-crud-parity-schoolbell-e-spinoff-platform.md 정렬) — spinoff-platform의 범용 member 리소스(`OrgMembersService.update()`, patch 객체)와 같은 외형으로, URL에 필드를 박아 넣지 않고(`.../role`, `.../name` ...) 이 하나의 엔드포인트가 body 필드로 여러 종류의 갱신을 받는다(2026-08-19 사용자 결정 — 필드가 늘 때마다 엔드포인트가 늘어나는 것을 피한다). 모든 필드가 옵셔널이다(PATCH 부분 갱신 원칙 — 생략한 필드는 건드리지 않고, null/빈 문자열은 지운다는 뜻이다). role=Owner/Admin은 대상이 Faculty/Admin/Owner 중 하나일 때만 허용(Student/Parent는 대상이 될 수 없다 — Admin↔Owner 직접 전환도 이 조건으로 허용됨), role=Member는 대상이 현재 Admin/Owner일 때만 허용하고, 단체의 마지막 Owner 는 Admin/Member 로 내릴 수 없다(409 LAST_ORG_OWNER). role은 org 직속 멤버만 대상이다(team 소속 멤버는 400) — name/phone/contacts는 org 직속·team 소속 무관하게 이 멤버 자신의 자리면 대상이 된다. contacts는 이 멤버(Student)의 Parent1/2 형제 row를 지목하는 부분 patch 배열이다 — 지목하지 않은 형제 row는 절대 건드리지 않는다(update-member.dto.ts 문서 참고). 이 자리(id)는 그대로 유지된다(in-place 갱신).
 * @summary 단체 구성원 갱신 (role 전환 + 본인 name/phone + contacts(Parent1/2) 부분 patch, org admin 세션 또는 org.members.admin OAuth)
 */
 orgMembersControllerUpdateMember<TData = OrgMemberDto>(orgId: string,
    memberId: string,
    updateMemberDto: UpdateMemberDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMembersControllerUpdateMember<TData = OrgMemberDto>(orgId: string,
    memberId: string,
    updateMemberDto: UpdateMemberDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMembersControllerUpdateMember<TData = OrgMemberDto>(orgId: string,
    memberId: string,
    updateMemberDto: UpdateMemberDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMembersControllerUpdateMember<TData = OrgMemberDto>(
    orgId: string,
    memberId: string,
    updateMemberDto: UpdateMemberDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}`,
      updateMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}`,
      updateMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}`,
      updateMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * "이전 자리 X(sameAsMemberId) = 새 자리(:memberId), 동일인"을 사람이 확인해 연결한다. sameAsMemberId를 생략하면 새 연속성을 만든다(전입생 등). 이미 continuity가 있는 자리를 다시 호출하면 그 값이 덮어써진다 — 오연결 정정도 이 하나의 엔드포인트가 담당한다. sameAsMemberId가 다른 단체 소속이면 404(cross-org 연결은 v1에서 차단, create-continuity-link.dto.ts/서비스 참고).
 * @summary 자리(GroupMember) 다년 연속성 수동 연결/재연결 (org admin 세션 전용, OAuth 미지원)
 */
 orgMemberContinuityControllerCreateLink<TData = ContinuityLinkDto>(orgId: string,
    memberId: string,
    createContinuityLinkDto: CreateContinuityLinkDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMemberContinuityControllerCreateLink<TData = ContinuityLinkDto>(orgId: string,
    memberId: string,
    createContinuityLinkDto: CreateContinuityLinkDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMemberContinuityControllerCreateLink<TData = ContinuityLinkDto>(orgId: string,
    memberId: string,
    createContinuityLinkDto: CreateContinuityLinkDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMemberContinuityControllerCreateLink<TData = ContinuityLinkDto>(
    orgId: string,
    memberId: string,
    createContinuityLinkDto: CreateContinuityLinkDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/continuity-links`,
      createContinuityLinkDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/continuity-links`,
      createContinuityLinkDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/continuity-links`,
      createContinuityLinkDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 소유 계정 자리의 로그인 코드를 새로 발급한다 — **재발급이 폐기를 겸한다**(자리당 활성 코드는 하나이고 이전 코드는 즉시 쓸 수 없다). 계정·권한은 그대로이고 코드만 바뀐다. 응답의 `login.code`는 이 응답에서 한 번만 볼 수 있다. 소유 계정이 아닌 자리(일반 멤버·다른 단체의 자리)는 404다. 코드를 아예 막으려면 자리를 삭제한다.
 * @summary 단체 소유 멤버의 로그인 코드 재발급 (이전 코드는 즉시 폐기, org admin 세션)
 */
 orgManagedUsersControllerReissue<TData = ReissuedManagedCredentialDto>(orgId: string,
    memberId: string,
    reissueManagedCredentialBodyDto: ReissueManagedCredentialBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgManagedUsersControllerReissue<TData = ReissuedManagedCredentialDto>(orgId: string,
    memberId: string,
    reissueManagedCredentialBodyDto: ReissueManagedCredentialBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgManagedUsersControllerReissue<TData = ReissuedManagedCredentialDto>(orgId: string,
    memberId: string,
    reissueManagedCredentialBodyDto: ReissueManagedCredentialBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgManagedUsersControllerReissue<TData = ReissuedManagedCredentialDto>(
    orgId: string,
    memberId: string,
    reissueManagedCredentialBodyDto: ReissueManagedCredentialBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/managed-credential`,
      reissueManagedCredentialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/managed-credential`,
      reissueManagedCredentialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/managed-credential`,
      reissueManagedCredentialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * afterMemberId 를 생략하거나 null 로 보내면 그 레벨(같은 팀·같은 memberType)의 맨 앞으로 옮긴다. 서버가 결번을 보존하는 gap/push 알고리즘으로 memberNum 을 계산해 바뀌는 행만 갱신한다. 기준이 같은 레벨 형제가 아니면 400. 응답은 본문 없음(204) — 바뀐 번호는 목록을 다시 조회해 읽는다.
 * @summary 단체 구성원 표시 순서 재배치 — 같은 레벨 형제 중 afterMemberId 바로 뒤로 (org admin 세션 또는 org.members.admin OAuth)
 */
 orgMembersControllerUpdateMemberSortKey<TData = void>(orgId: string,
    memberId: string,
    updateMemberSortKeyDto: UpdateMemberSortKeyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMembersControllerUpdateMemberSortKey<TData = void>(orgId: string,
    memberId: string,
    updateMemberSortKeyDto: UpdateMemberSortKeyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMembersControllerUpdateMemberSortKey<TData = void>(orgId: string,
    memberId: string,
    updateMemberSortKeyDto: UpdateMemberSortKeyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMembersControllerUpdateMemberSortKey<TData = void>(
    orgId: string,
    memberId: string,
    updateMemberSortKeyDto: UpdateMemberSortKeyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}/sort-key`,
      updateMemberSortKeyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}/sort-key`,
      updateMemberSortKeyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}/sort-key`,
      updateMemberSortKeyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 권한 부여 현황 조회 (org admin 세션 전용)
 */
 orgPermissionsControllerList<TData = OrgPermissionListResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgPermissionsControllerList<TData = OrgPermissionListResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgPermissionsControllerList<TData = OrgPermissionListResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgPermissionsControllerList<TData = OrgPermissionListResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 권한 부여 (org admin 세션 전용) — memberId/labelId/targetRefKey 중 정확히 하나
 */
 orgPermissionsControllerGrant<TData = OrgPermissionDto>(orgId: string,
    grantOrgPermissionDto: GrantOrgPermissionDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgPermissionsControllerGrant<TData = OrgPermissionDto>(orgId: string,
    grantOrgPermissionDto: GrantOrgPermissionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgPermissionsControllerGrant<TData = OrgPermissionDto>(orgId: string,
    grantOrgPermissionDto: GrantOrgPermissionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgPermissionsControllerGrant<TData = OrgPermissionDto>(
    orgId: string,
    grantOrgPermissionDto: GrantOrgPermissionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/permissions`,
      grantOrgPermissionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/permissions`,
      grantOrgPermissionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/permissions`,
      grantOrgPermissionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 권한 회수 (org admin 세션 전용)
 */
 orgPermissionsControllerRevoke<TData = void>(orgId: string,
    permissionId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgPermissionsControllerRevoke<TData = void>(orgId: string,
    permissionId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgPermissionsControllerRevoke<TData = void>(orgId: string,
    permissionId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgPermissionsControllerRevoke<TData = void>(
    orgId: string,
    permissionId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/permissions/${permissionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/permissions/${permissionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/permissions/${permissionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 대상은 memberIds(자리 id), userIds(계정 id, "{shard}:{id}"), targets(수신자별 내용) 중 정확히 하나로 지정한다. 어느 방식이든 이 단체(하위 team 포함)에서 수락(Joined)한 자리의 계정만 대상이 되고, 초대 전·대기·거절·탈퇴 상태의 자리와 단체 밖 대상은 조용히 제외된다(소속·수락 여부가 응답으로 새지 않게). idempotencyKey를 주면 같은 (호출 App, 키)의 재요청은 새 메시지를 만들지 않고 내용과 무관하게 409(code=IDEMPOTENCY_KEY_ALREADY_ACCEPTED)로 거부하며, 본문의 messageId·acceptedAt이 처음 접수한 것이다. 크기 상한: 요청 본문 1MB(초과 시 413), 수신자별 최종 title·body·data는 UTF-8 4096바이트(키 이름과 발송 시 붙는 deliveryId 포함, 초과 시 400), targets에서 같은 userId에 붙일 수 있는 항목은 한 요청당 20개(초과 시 400).
 * @summary 단체 앞 멤버에게 FCM 알림 발행(비동기, outbox)
 */
 fcmNotificationsControllerSendNotification<TData = OrgNotificationAcceptedDto>(orgId: string,
    sendOrgNotificationDto: SendOrgNotificationDto, options?: HttpClientBodyOptions): Observable<TData>;
 fcmNotificationsControllerSendNotification<TData = OrgNotificationAcceptedDto>(orgId: string,
    sendOrgNotificationDto: SendOrgNotificationDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 fcmNotificationsControllerSendNotification<TData = OrgNotificationAcceptedDto>(orgId: string,
    sendOrgNotificationDto: SendOrgNotificationDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  fcmNotificationsControllerSendNotification<TData = OrgNotificationAcceptedDto>(
    orgId: string,
    sendOrgNotificationDto: SendOrgNotificationDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/pushes`,
      sendOrgNotificationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/pushes`,
      sendOrgNotificationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/pushes`,
      sendOrgNotificationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 노출 판정을 통과한 서비스만 돌려준다. 수락한 자리가 없으면 403.
 * @summary 이 단체에서 내가 볼 수 있는 서비스 목록(유효 순서)
 */
 magicLinkEntryControllerListVisibleServices<TData = VisibleServiceDto[]>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 magicLinkEntryControllerListVisibleServices<TData = VisibleServiceDto[]>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 magicLinkEntryControllerListVisibleServices<TData = VisibleServiceDto[]>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  magicLinkEntryControllerListVisibleServices<TData = VisibleServiceDto[]>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/services`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/services`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/services`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 팀(반) 목록 조회 (OAuth access token 또는 자체 로그인 세션)
 */
 orgTeamsControllerListTeams<TData = OrgTeamListResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerListTeams<TData = OrgTeamListResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerListTeams<TData = OrgTeamListResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerListTeams<TData = OrgTeamListResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀(반) 생성 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만)
 */
 orgTeamsControllerCreateTeam<TData = OrgTeamDto>(orgId: string,
    createOrgTeamDto: CreateOrgTeamDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerCreateTeam<TData = OrgTeamDto>(orgId: string,
    createOrgTeamDto: CreateOrgTeamDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerCreateTeam<TData = OrgTeamDto>(orgId: string,
    createOrgTeamDto: CreateOrgTeamDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerCreateTeam<TData = OrgTeamDto>(
    orgId: string,
    createOrgTeamDto: CreateOrgTeamDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams`,
      createOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams`,
      createOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/teams`,
      createOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀(반) 생성/이름변경/삭제/이동 배치 처리 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만)
 */
 orgTeamsControllerBatchWriteTeams<TData = OrgTeamListResponseDto>(orgId: string,
    batchOrgTeamsBodyDto: BatchOrgTeamsBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerBatchWriteTeams<TData = OrgTeamListResponseDto>(orgId: string,
    batchOrgTeamsBodyDto: BatchOrgTeamsBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerBatchWriteTeams<TData = OrgTeamListResponseDto>(orgId: string,
    batchOrgTeamsBodyDto: BatchOrgTeamsBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerBatchWriteTeams<TData = OrgTeamListResponseDto>(
    orgId: string,
    batchOrgTeamsBodyDto: BatchOrgTeamsBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/batch`,
      batchOrgTeamsBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/batch`,
      batchOrgTeamsBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/teams/batch`,
      batchOrgTeamsBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀(반) 삭제 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만) — 하위 team·소속 구성원까지 함께 soft-delete된다. OAuth RP는 서브트리 전체가 본인 소유일 때만 가능(org.teams.admin이면 무관)
 */
 orgTeamsControllerDeleteTeam<TData = void>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerDeleteTeam<TData = void>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerDeleteTeam<TData = void>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerDeleteTeam<TData = void>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀(반) 단건 조회 — 팀 뷰용 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원 또는 이 팀 소속 구성원)
 */
 orgTeamsControllerGetTeam<TData = OrgTeamDetailDto>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerGetTeam<TData = OrgTeamDetailDto>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerGetTeam<TData = OrgTeamDetailDto>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerGetTeam<TData = OrgTeamDetailDto>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀(반) 이름 변경 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원 또는 그 팀의 owner/admin만) — OAuth RP는 본인이 만든 team만 가능(org.teams.admin이면 전부 가능)
 */
 orgTeamsControllerRenameTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    updateOrgTeamDto: UpdateOrgTeamDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerRenameTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    updateOrgTeamDto: UpdateOrgTeamDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerRenameTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    updateOrgTeamDto: UpdateOrgTeamDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerRenameTeam<TData = OrgTeamDto>(
    orgId: string,
    teamId: string,
    updateOrgTeamDto: UpdateOrgTeamDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}`,
      updateOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}`,
      updateOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}`,
      updateOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀(반) Owner·Admin 목록 조회 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원 또는 그 팀의 owner/admin만)
 */
 orgTeamsControllerListTeamAdmins<TData = TeamAdminListResponseDto>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerListTeamAdmins<TData = TeamAdminListResponseDto>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerListTeamAdmins<TData = TeamAdminListResponseDto>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerListTeamAdmins<TData = TeamAdminListResponseDto>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/admins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/admins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/admins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 상위 층이 해당 프로퍼티(visibleDelegable·sortDelegable)를 위임한 경우에만 값을 쓸 수 있다. 팀 관리자는 자기 팀과 자손에만 쓴다.
 * @summary 팀 단위 서비스 설정 쓰기
 */
 appLayerSettingControllerPutTeamSetting<TData = void>(orgId: string,
    teamId: string,
    appId: string,
    putAppLayerSettingDto: PutAppLayerSettingDto, options?: HttpClientBodyOptions): Observable<TData>;
 appLayerSettingControllerPutTeamSetting<TData = void>(orgId: string,
    teamId: string,
    appId: string,
    putAppLayerSettingDto: PutAppLayerSettingDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 appLayerSettingControllerPutTeamSetting<TData = void>(orgId: string,
    teamId: string,
    appId: string,
    putAppLayerSettingDto: PutAppLayerSettingDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  appLayerSettingControllerPutTeamSetting<TData = void>(
    orgId: string,
    teamId: string,
    appId: string,
    putAppLayerSettingDto: PutAppLayerSettingDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/orgs/${orgId}/teams/${teamId}/apps/${appId}/setting`,
      putAppLayerSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/orgs/${orgId}/teams/${teamId}/apps/${appId}/setting`,
      putAppLayerSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/orgs/${orgId}/teams/${teamId}/apps/${appId}/setting`,
      putAppLayerSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀(반) 소속 구성원 목록 조회 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만)
 */
 orgTeamsControllerListTeamMembers<TData = OrgMemberListResponseDto>(orgId: string,
    teamId: string,
    params?: OrgTeamsControllerListTeamMembersParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerListTeamMembers<TData = OrgMemberListResponseDto>(orgId: string,
    teamId: string,
    params?: OrgTeamsControllerListTeamMembersParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerListTeamMembers<TData = OrgMemberListResponseDto>(orgId: string,
    teamId: string,
    params?: OrgTeamsControllerListTeamMembersParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerListTeamMembers<TData = OrgMemberListResponseDto>(
    orgId: string,
    teamId: string,
    params?: OrgTeamsControllerListTeamMembersParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 팀 멤버 생성 — org admin 또는 이 학급의 owner/admin(세션, role 별 허용 여부는 권한 규칙으로 판정), 또는 org.team-members.write OAuth RP(본인이 만든 team만, .admin이면 전부 가능)
 */
 orgTeamsControllerCreateTeamMember<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    addTeamMemberDto: AddTeamMemberDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerCreateTeamMember<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    addTeamMemberDto: AddTeamMemberDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerCreateTeamMember<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    addTeamMemberDto: AddTeamMemberDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerCreateTeamMember<TData = OrgMemberDto>(
    orgId: string,
    teamId: string,
    addTeamMemberDto: AddTeamMemberDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,
      addTeamMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,
      addTeamMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,
      addTeamMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 요청 body는 org-level POST /orgs/:orgId/members/batch와 동일한 discriminated union(type: create/update/delete)이다 — sameAsMemberId(다년 연속성 승계)/idempotencyKey(멱등 생성 키)/externalRefKey(유일하지 않은 참조 값)도 동일하게 지원한다. teamId는 URL로 고정되므로 항목의 teamId 필드는 생략하거나 이 teamId와 같아야 한다(다르면 400). create 는 이 팀의 학생만 만든다(보호자는 생성 뒤 contacts 로 추가). update/delete 대상도 이 teamId 소속 학생·보호자가 아니면 400.
 * @summary 학급 소속 구성원(Student/Parent1/Parent2) 일괄 생성/수정/삭제 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원 또는 그 학급의 owner/admin만) — 담임은 이 API로 만들 수 없다(addTeamAdmin 참고). OAuth RP는 org.team-non-admin-members.write(또는 이를 포함하는 org.team-members.write)면 본인이 만든 team만 가능(.admin류면 전부 가능)
 */
 orgTeamsControllerBatchWriteTeamMembers<TData = OrgMemberListResponseDto>(orgId: string,
    teamId: string,
    batchMembersBodyDto: BatchMembersBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerBatchWriteTeamMembers<TData = OrgMemberListResponseDto>(orgId: string,
    teamId: string,
    batchMembersBodyDto: BatchMembersBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerBatchWriteTeamMembers<TData = OrgMemberListResponseDto>(orgId: string,
    teamId: string,
    batchMembersBodyDto: BatchMembersBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerBatchWriteTeamMembers<TData = OrgMemberListResponseDto>(
    orgId: string,
    teamId: string,
    batchMembersBodyDto: BatchMembersBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/batch`,
      batchMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/batch`,
      batchMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/batch`,
      batchMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀 멤버 삭제 — org admin 또는 이 학급의 owner/admin(세션, role 별 허용 여부는 권한 규칙으로 판정), 또는 org.team-members.write OAuth RP(본인이 만든 team만, .admin이면 전부 가능)
 */
 orgTeamsControllerDeleteTeamMember<TData = void>(orgId: string,
    teamId: string,
    memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerDeleteTeamMember<TData = void>(orgId: string,
    teamId: string,
    memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerDeleteTeamMember<TData = void>(orgId: string,
    teamId: string,
    memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerDeleteTeamMember<TData = void>(
    orgId: string,
    teamId: string,
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀 멤버 역할 전환(Admin↔Owner) — org admin 또는 이 학급의 owner(세션, 권한 규칙으로 판정), 또는 org.team-members.write OAuth RP(본인이 만든 team만, .admin이면 전부 가능)
 */
 orgTeamsControllerUpdateTeamMemberRole<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    memberId: string,
    updateTeamMemberRoleDto: UpdateTeamMemberRoleDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerUpdateTeamMemberRole<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    memberId: string,
    updateTeamMemberRoleDto: UpdateTeamMemberRoleDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerUpdateTeamMemberRole<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    memberId: string,
    updateTeamMemberRoleDto: UpdateTeamMemberRoleDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerUpdateTeamMemberRole<TData = OrgMemberDto>(
    orgId: string,
    teamId: string,
    memberId: string,
    updateTeamMemberRoleDto: UpdateTeamMemberRoleDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}/role`,
      updateTeamMemberRoleDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}/role`,
      updateTeamMemberRoleDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}/role`,
      updateTeamMemberRoleDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀(반) 이동(다른 부모로) + 형제 사이 순서변경 (OAuth access token, 또는 자체 로그인 세션 — 세션은 org admin/교직원만) — OAuth RP는 본인이 만든 team만 가능(org.teams.admin이면 전부 가능)
 */
 orgTeamsControllerMoveTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    moveOrgTeamDto: MoveOrgTeamDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTeamsControllerMoveTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    moveOrgTeamDto: MoveOrgTeamDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTeamsControllerMoveTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    moveOrgTeamDto: MoveOrgTeamDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTeamsControllerMoveTeam<TData = OrgTeamDto>(
    orgId: string,
    teamId: string,
    moveOrgTeamDto: MoveOrgTeamDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/position`,
      moveOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/position`,
      moveOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/position`,
      moveOrgTeamDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 서비스마다 이 팀의 유효·저장 값과 각 값을 바꿀 수 있는지(바꿀 수 없으면 위임이 끊긴 층)를 돌려준다. 이 단체의 팀이 아니면 404.
 * @summary 팀의 서비스별 노출·순서 설정 상태(유효 순서)
 */
 teamServiceSettingControllerList<TData = TeamServiceSettingDto[]>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 teamServiceSettingControllerList<TData = TeamServiceSettingDto[]>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 teamServiceSettingControllerList<TData = TeamServiceSettingDto[]>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  teamServiceSettingControllerList<TData = TeamServiceSettingDto[]>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/service-settings`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/service-settings`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/service-settings`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 팀 행의 숨김·위임까지 반영한 노출 판정을 통과하고 팀 진입을 받는 서비스만 돌려준다. 이 단체의 팀이 아니면 404, 입장 자격이 없으면 403.
 * @summary 이 팀 컨텍스트에서 내가 볼 수 있는 서비스 목록(유효 순서)
 */
 magicLinkEntryControllerListVisibleServicesForTeam<TData = VisibleServiceDto[]>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 magicLinkEntryControllerListVisibleServicesForTeam<TData = VisibleServiceDto[]>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 magicLinkEntryControllerListVisibleServicesForTeam<TData = VisibleServiceDto[]>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  magicLinkEntryControllerListVisibleServicesForTeam<TData = VisibleServiceDto[]>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/services`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/services`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/services`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 푸시 접수 때 보낸 `externalRefKey` 로 그 푸시(조각·재발송 포함)의 수신자별 받음·열음을 조회한다(최대 100개). 호출 client 가 속한 App 이 접수한 푸시만 돌려주고, 없는 키·다른 App 의 키는 오류 없이 빠진다. 같은 수신자의 기기가 여럿이면 하나로 합친다(delivered > sent > failed > invalid > skipped, 시각은 가장 이른 값). 아직 처리 전인 기기만 있는 수신자는 목록에 없다. 한 호출이 돌려줄 수 있는 푸시는 최대 1,000건이고 넘으면 400 이다(키를 나눠 조회한다). 필요 스콥: `client.push-deliveries.read`(서비스 자격 토큰).
 * @summary 접수한 푸시의 받음/열음 조회(읽기 전용, 참조 키 배치)
 */
 pushDeliveriesControllerLookup<TData = LookupPushDeliveriesResponseDto>(params: PushDeliveriesControllerLookupParams, options?: HttpClientBodyOptions): Observable<TData>;
 pushDeliveriesControllerLookup<TData = LookupPushDeliveriesResponseDto>(params: PushDeliveriesControllerLookupParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 pushDeliveriesControllerLookup<TData = LookupPushDeliveriesResponseDto>(params: PushDeliveriesControllerLookupParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  pushDeliveriesControllerLookup<TData = LookupPushDeliveriesResponseDto>(
    params: PushDeliveriesControllerLookupParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/push-deliveries`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/push-deliveries`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/push-deliveries`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * RP 의 정기 잡이 자기가 아는 staff(`Staff.id`, 최대 100명)의 현재 전화번호와 활성 여부를 OP 의 값으로 맞춘다. 이벤트(`staff.contact-changed`)가 놓친 변경을 줍는 안전망이다. **호출 client 의 App 이 가진 staff 로그인용 client 에 들어올 자격이 있는 활성 staff 의 번호만** 돌려주고, 없는 id 와 자격이 없는 활성 staff 는 오류 없이 빠진다. 비활성화된 staff 는 번호 없이 `active: false` 로 돌려준다. 번호는 canonical E.164 일 때만 돌려주고 아니면 null 이다. 필요 스콥: `client.staff-contacts.read`(서비스 자격 토큰).
 * @summary staff 의 전화번호·활성 여부 일괄 조회(읽기 전용, 서비스 자격)
 */
 staffContactsControllerLookup<TData = LookupStaffContactsResponseDto>(lookupStaffContactsDto: LookupStaffContactsDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffContactsControllerLookup<TData = LookupStaffContactsResponseDto>(lookupStaffContactsDto: LookupStaffContactsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffContactsControllerLookup<TData = LookupStaffContactsResponseDto>(lookupStaffContactsDto: LookupStaffContactsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffContactsControllerLookup<TData = LookupStaffContactsResponseDto>(
    lookupStaffContactsDto: LookupStaffContactsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff-contacts/lookup`,
      lookupStaffContactsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff-contacts/lookup`,
      lookupStaffContactsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff-contacts/lookup`,
      lookupStaffContactsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 스태프 목록(Accepted + Pending 통합, 페이지네이션)
 */
 staffManagementControllerListStaff<TData = StaffListResponseDto>(params?: StaffManagementControllerListStaffParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerListStaff<TData = StaffListResponseDto>(params?: StaffManagementControllerListStaffParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerListStaff<TData = StaffListResponseDto>(params?: StaffManagementControllerListStaffParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerListStaff<TData = StaffListResponseDto>(
    params?: StaffManagementControllerListStaffParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff-management/staff`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff-management/staff`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff-management/staff`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 스태프 초대 발송(Staff Pending + StaffInvitation Pending)
 */
 staffManagementControllerCreateInvitation<TData = StaffInvitationResponseDto>(createStaffInvitationDto: CreateStaffInvitationDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerCreateInvitation<TData = StaffInvitationResponseDto>(createStaffInvitationDto: CreateStaffInvitationDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerCreateInvitation<TData = StaffInvitationResponseDto>(createStaffInvitationDto: CreateStaffInvitationDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerCreateInvitation<TData = StaffInvitationResponseDto>(
    createStaffInvitationDto: CreateStaffInvitationDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff-management/staff-invitations`,
      createStaffInvitationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff-management/staff-invitations`,
      createStaffInvitationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff-management/staff-invitations`,
      createStaffInvitationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 초대 취소(Pending invitation → Cancelled + Staff placeholder hard delete)
 */
 staffManagementControllerCancelInvitation<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerCancelInvitation<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerCancelInvitation<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerCancelInvitation<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/staff-management/staff-invitations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/staff-management/staff-invitations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/staff-management/staff-invitations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 스태프 soft delete(Staff.deletedAt + 세션 폐기)
 */
 staffManagementControllerSoftDeleteStaff<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerSoftDeleteStaff<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerSoftDeleteStaff<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerSoftDeleteStaff<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/staff-management/staff/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/staff-management/staff/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/staff-management/staff/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 스태프 상세(role, scope, team, pending invitation 포함)
 */
 staffManagementControllerGetStaff<TData = StaffDetailDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerGetStaff<TData = StaffDetailDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerGetStaff<TData = StaffDetailDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerGetStaff<TData = StaffDetailDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff-management/staff/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff-management/staff/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff-management/staff/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 스태프 수정(phone/name)
 */
 staffManagementControllerUpdateStaff<TData = StaffListItemDto>(id: string,
    updateStaffDto: UpdateStaffDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerUpdateStaff<TData = StaffListItemDto>(id: string,
    updateStaffDto: UpdateStaffDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerUpdateStaff<TData = StaffListItemDto>(id: string,
    updateStaffDto: UpdateStaffDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerUpdateStaff<TData = StaffListItemDto>(
    id: string,
    updateStaffDto: UpdateStaffDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/staff-management/staff/${id}`,
      updateStaffDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/staff-management/staff/${id}`,
      updateStaffDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/staff-management/staff/${id}`,
      updateStaffDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 스태프 role 변경(Owner/Member) — 응답에 이전 역할(previousRole)을 담는다
 */
 staffManagementControllerUpdateStaffRole<TData = UpdateStaffRoleResponseDto>(id: string,
    updateStaffRoleDto: UpdateStaffRoleDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerUpdateStaffRole<TData = UpdateStaffRoleResponseDto>(id: string,
    updateStaffRoleDto: UpdateStaffRoleDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerUpdateStaffRole<TData = UpdateStaffRoleResponseDto>(id: string,
    updateStaffRoleDto: UpdateStaffRoleDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerUpdateStaffRole<TData = UpdateStaffRoleResponseDto>(
    id: string,
    updateStaffRoleDto: UpdateStaffRoleDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/staff-management/staff/${id}/role`,
      updateStaffRoleDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/staff-management/staff/${id}/role`,
      updateStaffRoleDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/staff-management/staff/${id}/role`,
      updateStaffRoleDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 스태프 scope 목록(direct + effective)
 */
 staffManagementControllerListScopes<TData = StaffScopesResponseDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerListScopes<TData = StaffScopesResponseDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerListScopes<TData = StaffScopesResponseDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerListScopes<TData = StaffScopesResponseDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff-management/staff/${id}/scopes`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff-management/staff/${id}/scopes`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff-management/staff/${id}/scopes`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 스태프 direct scope 추가·제거 — 응답에 실제 적용된 변경(added·removed)을 담는다
 */
 staffManagementControllerUpdateScopes<TData = UpdateStaffScopesResponseDto>(id: string,
    updateStaffScopesDto: UpdateStaffScopesDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerUpdateScopes<TData = UpdateStaffScopesResponseDto>(id: string,
    updateStaffScopesDto: UpdateStaffScopesDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerUpdateScopes<TData = UpdateStaffScopesResponseDto>(id: string,
    updateStaffScopesDto: UpdateStaffScopesDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerUpdateScopes<TData = UpdateStaffScopesResponseDto>(
    id: string,
    updateStaffScopesDto: UpdateStaffScopesDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/staff-management/staff/${id}/scopes`,
      updateStaffScopesDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/staff-management/staff/${id}/scopes`,
      updateStaffScopesDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/staff-management/staff/${id}/scopes`,
      updateStaffScopesDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 관리자 강제 로그아웃(전 세션 폐기)
 */
 staffManagementControllerDestroyStaffSessions<TData = DestroyStaffSessionsResponseDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffManagementControllerDestroyStaffSessions<TData = DestroyStaffSessionsResponseDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffManagementControllerDestroyStaffSessions<TData = DestroyStaffSessionsResponseDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffManagementControllerDestroyStaffSessions<TData = DestroyStaffSessionsResponseDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/staff-management/staff/${id}/sessions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/staff-management/staff/${id}/sessions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/staff-management/staff/${id}/sessions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 서비스 프로필 목록(구성된 App만)
 */
 staffAppServiceProfileControllerList<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 staffAppServiceProfileControllerList<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAppServiceProfileControllerList<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAppServiceProfileControllerList<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/app-service-profiles`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/app-service-profiles`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/app-service-profiles`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 서비스 프로필 상세 — 행이 없으면 404(미구성)
 */
 staffAppServiceProfileControllerGet<TData = void>(appId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffAppServiceProfileControllerGet<TData = void>(appId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAppServiceProfileControllerGet<TData = void>(appId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAppServiceProfileControllerGet<TData = void>(
    appId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/app-service-profiles/${appId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/app-service-profiles/${appId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/app-service-profiles/${appId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 모든 축을 명시해야 한다(부분 갱신 없음). supportedEntryUnits는 최소 1개이며 모르는 값·중복은 400.
 * @summary 서비스 프로필 전체 교체(생성 포함, 서비스 행 함께 씀)
 */
 staffAppServiceProfileControllerPut<TData = void>(appId: string,
    putAppServiceProfileDto: PutAppServiceProfileDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffAppServiceProfileControllerPut<TData = void>(appId: string,
    putAppServiceProfileDto: PutAppServiceProfileDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAppServiceProfileControllerPut<TData = void>(appId: string,
    putAppServiceProfileDto: PutAppServiceProfileDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAppServiceProfileControllerPut<TData = void>(
    appId: string,
    putAppServiceProfileDto: PutAppServiceProfileDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/staff/app-service-profiles/${appId}`,
      putAppServiceProfileDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/staff/app-service-profiles/${appId}`,
      putAppServiceProfileDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/staff/app-service-profiles/${appId}`,
      putAppServiceProfileDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 앱의 웹훅 엔드포인트 목록(삭제된 것 제외, 시크릿 원문 없음) (staff 전용)
 */
 staffWebhookEndpointsControllerList<TData = WebhookEndpointDto[]>(appId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffWebhookEndpointsControllerList<TData = WebhookEndpointDto[]>(appId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffWebhookEndpointsControllerList<TData = WebhookEndpointDto[]>(appId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffWebhookEndpointsControllerList<TData = WebhookEndpointDto[]>(
    appId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 앱의 웹훅 엔드포인트 만들기 — resourceRefKeys 를 생략하면 앱의 모든 client, 주면 그 client 들만 (staff 전용)
 */
 staffWebhookEndpointsControllerCreate<TData = WebhookEndpointDto>(appId: string,
    createWebhookEndpointDto: CreateWebhookEndpointDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffWebhookEndpointsControllerCreate<TData = WebhookEndpointDto>(appId: string,
    createWebhookEndpointDto: CreateWebhookEndpointDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffWebhookEndpointsControllerCreate<TData = WebhookEndpointDto>(appId: string,
    createWebhookEndpointDto: CreateWebhookEndpointDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffWebhookEndpointsControllerCreate<TData = WebhookEndpointDto>(
    appId: string,
    createWebhookEndpointDto: CreateWebhookEndpointDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/apps/${appId}/webhook-endpoints`,
      createWebhookEndpointDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/apps/${appId}/webhook-endpoints`,
      createWebhookEndpointDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/apps/${appId}/webhook-endpoints`,
      createWebhookEndpointDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 웹훅 엔드포인트 삭제 — 서명 시크릿도 함께 지워진다 (staff 전용)
 */
 staffWebhookEndpointsControllerRemove<TData = void>(appId: string,
    endpointId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffWebhookEndpointsControllerRemove<TData = void>(appId: string,
    endpointId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffWebhookEndpointsControllerRemove<TData = void>(appId: string,
    endpointId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffWebhookEndpointsControllerRemove<TData = void>(
    appId: string,
    endpointId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 웹훅 엔드포인트 한 건 (staff 전용)
 */
 staffWebhookEndpointsControllerGet<TData = WebhookEndpointDto>(appId: string,
    endpointId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffWebhookEndpointsControllerGet<TData = WebhookEndpointDto>(appId: string,
    endpointId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffWebhookEndpointsControllerGet<TData = WebhookEndpointDto>(appId: string,
    endpointId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffWebhookEndpointsControllerGet<TData = WebhookEndpointDto>(
    appId: string,
    endpointId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 이름·URL·받을 client 바꾸기 (staff 전용)
 */
 staffWebhookEndpointsControllerUpdate<TData = WebhookEndpointDto>(appId: string,
    endpointId: string,
    updateWebhookEndpointDto: UpdateWebhookEndpointDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffWebhookEndpointsControllerUpdate<TData = WebhookEndpointDto>(appId: string,
    endpointId: string,
    updateWebhookEndpointDto: UpdateWebhookEndpointDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffWebhookEndpointsControllerUpdate<TData = WebhookEndpointDto>(appId: string,
    endpointId: string,
    updateWebhookEndpointDto: UpdateWebhookEndpointDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffWebhookEndpointsControllerUpdate<TData = WebhookEndpointDto>(
    appId: string,
    endpointId: string,
    updateWebhookEndpointDto: UpdateWebhookEndpointDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,
      updateWebhookEndpointDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,
      updateWebhookEndpointDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}`,
      updateWebhookEndpointDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 서명 시크릿 지우기 — 지우면 새 시크릿을 설정할 때까지 이 엔드포인트로는 발송되지 않는다 (staff 전용)
 */
 staffWebhookEndpointsControllerDeleteSecret<TData = void>(appId: string,
    endpointId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffWebhookEndpointsControllerDeleteSecret<TData = void>(appId: string,
    endpointId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffWebhookEndpointsControllerDeleteSecret<TData = void>(appId: string,
    endpointId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffWebhookEndpointsControllerDeleteSecret<TData = void>(
    appId: string,
    endpointId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 서명 시크릿 설정 여부(값은 돌려주지 않는다) (staff 전용)
 */
 staffWebhookEndpointsControllerDescribeSecret<TData = WebhookSigningSecretStatusDto>(appId: string,
    endpointId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffWebhookEndpointsControllerDescribeSecret<TData = WebhookSigningSecretStatusDto>(appId: string,
    endpointId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffWebhookEndpointsControllerDescribeSecret<TData = WebhookSigningSecretStatusDto>(appId: string,
    endpointId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffWebhookEndpointsControllerDescribeSecret<TData = WebhookSigningSecretStatusDto>(
    appId: string,
    endpointId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 서명 시크릿 설정·교체 — 본문에 시크릿이 없으면 서버가 만들어 응답에 한 번만 돌려준다 (staff 전용)
 */
 staffWebhookEndpointsControllerSetSecret<TData = SetWebhookSigningSecretResultDto>(appId: string,
    endpointId: string,
    setWebhookSigningSecretDto: SetWebhookSigningSecretDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffWebhookEndpointsControllerSetSecret<TData = SetWebhookSigningSecretResultDto>(appId: string,
    endpointId: string,
    setWebhookSigningSecretDto: SetWebhookSigningSecretDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffWebhookEndpointsControllerSetSecret<TData = SetWebhookSigningSecretResultDto>(appId: string,
    endpointId: string,
    setWebhookSigningSecretDto: SetWebhookSigningSecretDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffWebhookEndpointsControllerSetSecret<TData = SetWebhookSigningSecretResultDto>(
    appId: string,
    endpointId: string,
    setWebhookSigningSecretDto: SetWebhookSigningSecretDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,
      setWebhookSigningSecretDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,
      setWebhookSigningSecretDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/staff/apps/${appId}/webhook-endpoints/${endpointId}/secret`,
      setWebhookSigningSecretDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 미수락 초대 상세(없으면 null)
 */
 staffAuthControllerInvitation<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 staffAuthControllerInvitation<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAuthControllerInvitation<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAuthControllerInvitation<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/auth/invitation`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/auth/invitation`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/auth/invitation`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 초대 수락 — Staff.status를 Accepted로 전환
 */
 staffAuthControllerAcceptInvitation<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 staffAuthControllerAcceptInvitation<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAuthControllerAcceptInvitation<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAuthControllerAcceptInvitation<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/auth/invitation/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/auth/invitation/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/auth/invitation/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 초대 거절 — Staff.status를 Rejected로 전환, 세션은 별도로 로그아웃 필요
 */
 staffAuthControllerRejectInvitation<TData = void>(rejectInvitationDto: RejectInvitationDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffAuthControllerRejectInvitation<TData = void>(rejectInvitationDto: RejectInvitationDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAuthControllerRejectInvitation<TData = void>(rejectInvitationDto: RejectInvitationDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAuthControllerRejectInvitation<TData = void>(
    rejectInvitationDto: RejectInvitationDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/auth/invitation/reject`,
      rejectInvitationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/auth/invitation/reject`,
      rejectInvitationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/auth/invitation/reject`,
      rejectInvitationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 본문의 `accessToken`(메모리 보관, `Authorization: Bearer`)과 HttpOnly refresh 쿠키(`POST staff/auth/refresh` 로 회전, `POST staff/auth/signout` 으로 폐기)를 발급한다.
 * @summary staff 자체 로그인 — User.phone + password 인증 후 Staff 소속 확인, 스핀오프 세션 발급
 */
 staffAuthControllerLogin<TData = StaffLoginResponseDto>(staffLoginDto: StaffLoginDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffAuthControllerLogin<TData = StaffLoginResponseDto>(staffLoginDto: StaffLoginDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAuthControllerLogin<TData = StaffLoginResponseDto>(staffLoginDto: StaffLoginDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAuthControllerLogin<TData = StaffLoginResponseDto>(
    staffLoginDto: StaffLoginDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/auth/login`,
      staffLoginDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/auth/login`,
      staffLoginDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/auth/login`,
      staffLoginDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * staff-web 은 스핀오프 세션 access token 으로, RP 의 staff 로그인 콜백은 방금 받은 OIDC access token(`subject_type=staff`, `profile` scope)으로 부른다 — 둘 다 `Authorization: Bearer` 이고 발급자(`iss`)로 가른다. `phone` 은 OP 가 인증한 번호다(staff 로그인이 번호 미인증 계정을 막는다) — RP 는 이 값을 초대 매칭용 캐시로만 쓴다.
 * @summary 현재 staff 정보(초대 상태·전화번호 포함)
 */
 staffAuthControllerMe<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 staffAuthControllerMe<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAuthControllerMe<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAuthControllerMe<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary staff refresh token 회전 — SPA 부팅 시 세션 복원. 쿠키 채널만 받는다.
 */
 staffSessionControllerRefresh<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 staffSessionControllerRefresh<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffSessionControllerRefresh<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffSessionControllerRefresh<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/auth/refresh`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/auth/refresh`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/auth/refresh`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 로그아웃 — staff 세션의 refresh token 을 폐기하고 쿠키를 지운다
 */
 staffSessionControllerSignout<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 staffSessionControllerSignout<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffSessionControllerSignout<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffSessionControllerSignout<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/auth/signout`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/auth/signout`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/auth/signout`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * status/kind/appId 필터 선택 — kind 생략 시 Create/ScopeChange 둘 다 반환한다. staff-web App 심사 목록 화면의 기본 데이터 소스.
 * @summary App 심사 요청 통합 목록 (최초 신청 + scope 추가 신청)
 */
 staffOAuthAppApprovalRequestReviewControllerList<TData = void>(params?: StaffOAuthAppApprovalRequestReviewControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthAppApprovalRequestReviewControllerList<TData = void>(params?: StaffOAuthAppApprovalRequestReviewControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthAppApprovalRequestReviewControllerList<TData = void>(params?: StaffOAuthAppApprovalRequestReviewControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthAppApprovalRequestReviewControllerList<TData = void>(
    params?: StaffOAuthAppApprovalRequestReviewControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/oauth-app-approval-requests`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/oauth-app-approval-requests`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/oauth-app-approval-requests`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * status/appId 필터 선택 — appId는 staff-web App 상세 화면이 이 App의 요청 이력만 볼 때 쓴다.
 * @summary App scope 추가 요청 목록
 */
 staffOAuthAppScopeRequestReviewControllerList<TData = void>(params?: StaffOAuthAppScopeRequestReviewControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthAppScopeRequestReviewControllerList<TData = void>(params?: StaffOAuthAppScopeRequestReviewControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthAppScopeRequestReviewControllerList<TData = void>(params?: StaffOAuthAppScopeRequestReviewControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthAppScopeRequestReviewControllerList<TData = void>(
    params?: StaffOAuthAppScopeRequestReviewControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/oauth-app-scope-requests`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/oauth-app-scope-requests`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/oauth-app-scope-requests`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary App scope 추가 요청 상세
 */
 staffOAuthAppScopeRequestReviewControllerGet<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthAppScopeRequestReviewControllerGet<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthAppScopeRequestReviewControllerGet<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthAppScopeRequestReviewControllerGet<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/oauth-app-scope-requests/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/oauth-app-scope-requests/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/oauth-app-scope-requests/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 요청 승인 — app.allowedScopes를 requestedScopes로 갱신
 */
 staffOAuthAppScopeRequestReviewControllerApprove<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthAppScopeRequestReviewControllerApprove<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthAppScopeRequestReviewControllerApprove<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthAppScopeRequestReviewControllerApprove<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/oauth-app-scope-requests/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/oauth-app-scope-requests/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/oauth-app-scope-requests/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 요청 거절 — app.allowedScopes는 변경하지 않음
 */
 staffOAuthAppScopeRequestReviewControllerReject<TData = void>(id: string,
    rejectOAuthClientDto: RejectOAuthClientDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthAppScopeRequestReviewControllerReject<TData = void>(id: string,
    rejectOAuthClientDto: RejectOAuthClientDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthAppScopeRequestReviewControllerReject<TData = void>(id: string,
    rejectOAuthClientDto: RejectOAuthClientDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthAppScopeRequestReviewControllerReject<TData = void>(
    id: string,
    rejectOAuthClientDto: RejectOAuthClientDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/oauth-app-scope-requests/${id}/reject`,
      rejectOAuthClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/oauth-app-scope-requests/${id}/reject`,
      rejectOAuthClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/oauth-app-scope-requests/${id}/reject`,
      rejectOAuthClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary OAuth client 신청 목록 (status 필터 선택)
 */
 staffOAuthClientReviewControllerList<TData = void>(params?: StaffOAuthClientReviewControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthClientReviewControllerList<TData = void>(params?: StaffOAuthClientReviewControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthClientReviewControllerList<TData = void>(params?: StaffOAuthClientReviewControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthClientReviewControllerList<TData = void>(
    params?: StaffOAuthClientReviewControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/oauth-clients`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/oauth-clients`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/oauth-clients`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary OAuth client 신청 상세
 */
 staffOAuthClientReviewControllerGet<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthClientReviewControllerGet<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthClientReviewControllerGet<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthClientReviewControllerGet<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/oauth-clients/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/oauth-clients/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/oauth-clients/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 신청 승인 — status를 Approved로 전환
 */
 staffOAuthClientReviewControllerApprove<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthClientReviewControllerApprove<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthClientReviewControllerApprove<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthClientReviewControllerApprove<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/oauth-clients/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/oauth-clients/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/oauth-clients/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * offline_access는 신청 화이트리스트(EXTERNALLY_GRANTABLE_SCOPES)에 없어 신청자가 고를 수 없다. 미로그인 상태에서도 RP가 단체 자원에 접근하게 되는 스코프라 심사에서 별도로 판단한다. 승인 상태와 무관하게 호출 가능(이미 승인된 App에 나중에 부여하는 경우가 실제 사례) — Canceled 신청만 거부한다.
 * @summary offline_access 부여/회수 — 심사자 전용 결정
 */
 staffOAuthClientReviewControllerSetOfflineAccess<TData = void>(id: string,
    setOfflineAccessDto: SetOfflineAccessDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthClientReviewControllerSetOfflineAccess<TData = void>(id: string,
    setOfflineAccessDto: SetOfflineAccessDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthClientReviewControllerSetOfflineAccess<TData = void>(id: string,
    setOfflineAccessDto: SetOfflineAccessDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthClientReviewControllerSetOfflineAccess<TData = void>(
    id: string,
    setOfflineAccessDto: SetOfflineAccessDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/oauth-clients/${id}/offline-access`,
      setOfflineAccessDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/oauth-clients/${id}/offline-access`,
      setOfflineAccessDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/oauth-clients/${id}/offline-access`,
      setOfflineAccessDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 신청 거절 — status를 Rejected로 전환, 사유 기록
 */
 staffOAuthClientReviewControllerReject<TData = void>(id: string,
    rejectOAuthClientDto: RejectOAuthClientDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthClientReviewControllerReject<TData = void>(id: string,
    rejectOAuthClientDto: RejectOAuthClientDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthClientReviewControllerReject<TData = void>(id: string,
    rejectOAuthClientDto: RejectOAuthClientDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthClientReviewControllerReject<TData = void>(
    id: string,
    rejectOAuthClientDto: RejectOAuthClientDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/oauth-clients/${id}/reject`,
      rejectOAuthClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/oauth-clients/${id}/reject`,
      rejectOAuthClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/oauth-clients/${id}/reject`,
      rejectOAuthClientDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 오남용 발견 등으로 이미 승인된 scope를 축소할 때 쓴다. offline_access는 대상이 아니다 (POST .../offline-access 전용 엔드포인트로 다룬다). 없는 scope를 회수해도 멱등(no-op).
 * @summary 개별 scope 회수 — 이미 승인된 scope 하나를 제거
 */
 staffOAuthClientReviewControllerRevokeScope<TData = void>(id: string,
    revokeOAuthClientScopeDto: RevokeOAuthClientScopeDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffOAuthClientReviewControllerRevokeScope<TData = void>(id: string,
    revokeOAuthClientScopeDto: RevokeOAuthClientScopeDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOAuthClientReviewControllerRevokeScope<TData = void>(id: string,
    revokeOAuthClientScopeDto: RevokeOAuthClientScopeDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOAuthClientReviewControllerRevokeScope<TData = void>(
    id: string,
    revokeOAuthClientScopeDto: RevokeOAuthClientScopeDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/oauth-clients/${id}/scopes/revoke`,
      revokeOAuthClientScopeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/oauth-clients/${id}/scopes/revoke`,
      revokeOAuthClientScopeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/oauth-clients/${id}/scopes/revoke`,
      revokeOAuthClientScopeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * user_to_group 정리·멤버 FCM 푸시는 범위 밖(레거시 v5 disband()가 하던 일, 후속 과제). 이미 해체된 org를 다시 호출하면 원래 해체 시각·dissolvedTeamCount=0으로 멱등 응답한다.
 * @summary 단체 해체 — org와 모든 하위 team을 삭제 처리하고 grant를 가진 RP에 webhook 통지
 */
 staffOrgDissolveControllerDissolveOrg<TData = OrgDissolveResultDto>(orgId: string,
    dissolveOrgDto: DissolveOrgDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffOrgDissolveControllerDissolveOrg<TData = OrgDissolveResultDto>(orgId: string,
    dissolveOrgDto: DissolveOrgDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOrgDissolveControllerDissolveOrg<TData = OrgDissolveResultDto>(orgId: string,
    dissolveOrgDto: DissolveOrgDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOrgDissolveControllerDissolveOrg<TData = OrgDissolveResultDto>(
    orgId: string,
    dissolveOrgDto: DissolveOrgDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/orgs/${orgId}/dissolve`,
      dissolveOrgDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/orgs/${orgId}/dissolve`,
      dissolveOrgDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/orgs/${orgId}/dissolve`,
      dissolveOrgDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 좌석의 수락 상태(`org_group_member_status`) — 행이 없으면 status null
 */
 staffSeatAcceptanceControllerGetSeatAcceptance<TData = SeatAcceptanceDto>(orgId: string,
    memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffSeatAcceptanceControllerGetSeatAcceptance<TData = SeatAcceptanceDto>(orgId: string,
    memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffSeatAcceptanceControllerGetSeatAcceptance<TData = SeatAcceptanceDto>(orgId: string,
    memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffSeatAcceptanceControllerGetSeatAcceptance<TData = SeatAcceptanceDto>(
    orgId: string,
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/orgs/${orgId}/members/${memberId}/acceptance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/orgs/${orgId}/members/${memberId}/acceptance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/orgs/${orgId}/members/${memberId}/acceptance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * `ownerRefKey` 가 이 단체인 Task 만 나온다. payload·멱등 키는 노출하지 않는다.
 * @summary 단체 앞으로 걸린 Task 의 진행 상태(최신순, 최대 50건) — domain 은 앱이 허용한 목록 중 하나
 */
 staffOrgTaskLookupControllerList<TData = StaffOrgTaskViewDto[]>(orgId: string,
    params: StaffOrgTaskLookupControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffOrgTaskLookupControllerList<TData = StaffOrgTaskViewDto[]>(orgId: string,
    params: StaffOrgTaskLookupControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOrgTaskLookupControllerList<TData = StaffOrgTaskViewDto[]>(orgId: string,
    params: StaffOrgTaskLookupControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOrgTaskLookupControllerList<TData = StaffOrgTaskViewDto[]>(
    orgId: string,
    params: StaffOrgTaskLookupControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/orgs/${orgId}/tasks`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/orgs/${orgId}/tasks`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/orgs/${orgId}/tasks`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 전화번호 정확 일치로 사용자 1명 조회(없으면 404)
 */
 staffUserDevicesControllerLookup<TData = StaffUserDto>(params: StaffUserDevicesControllerLookupParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffUserDevicesControllerLookup<TData = StaffUserDto>(params: StaffUserDevicesControllerLookupParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffUserDevicesControllerLookup<TData = StaffUserDto>(params: StaffUserDevicesControllerLookupParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffUserDevicesControllerLookup<TData = StaffUserDto>(
    params: StaffUserDevicesControllerLookupParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/users/lookup`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/users/lookup`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/users/lookup`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 사용자 id로 사용자 1명 조회(없거나 삭제·단체 소유 계정이면 404)
 */
 staffUserDevicesControllerGetUser<TData = StaffUserDto>(userId: number, options?: HttpClientBodyOptions): Observable<TData>;
 staffUserDevicesControllerGetUser<TData = StaffUserDto>(userId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffUserDevicesControllerGetUser<TData = StaffUserDto>(userId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffUserDevicesControllerGetUser<TData = StaffUserDto>(
    userId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/users/${userId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/users/${userId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/users/${userId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 사용자에게 등록된 FCM 기기 목록(토큰은 끝 8자리만)
 */
 staffUserDevicesControllerListDevices<TData = StaffUserDeviceDto[]>(userId: number, options?: HttpClientBodyOptions): Observable<TData>;
 staffUserDevicesControllerListDevices<TData = StaffUserDeviceDto[]>(userId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffUserDevicesControllerListDevices<TData = StaffUserDeviceDto[]>(userId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffUserDevicesControllerListDevices<TData = StaffUserDeviceDto[]>(
    userId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/users/${userId}/devices`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/users/${userId}/devices`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/users/${userId}/devices`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 해당 사용자의 알림이 이 토큰의 기기로 전달된다. 감사 로그는 아직 남기지 않는다.
 * @summary 사용자 앞으로 FCM 기기 등록/갱신((userId, installationId) upsert)
 */
 staffUserDevicesControllerRegisterDevice<TData = void>(userId: number,
    registerFcmDeviceDto: RegisterFcmDeviceDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffUserDevicesControllerRegisterDevice<TData = void>(userId: number,
    registerFcmDeviceDto: RegisterFcmDeviceDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffUserDevicesControllerRegisterDevice<TData = void>(userId: number,
    registerFcmDeviceDto: RegisterFcmDeviceDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffUserDevicesControllerRegisterDevice<TData = void>(
    userId: number,
    registerFcmDeviceDto: RegisterFcmDeviceDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/staff/users/${userId}/devices`,
      registerFcmDeviceDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/staff/users/${userId}/devices`,
      registerFcmDeviceDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/staff/users/${userId}/devices`,
      registerFcmDeviceDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 사용자의 FCM 기기 삭제
 */
 staffUserDevicesControllerDeleteDevice<TData = void>(userId: number,
    deviceId: number, options?: HttpClientBodyOptions): Observable<TData>;
 staffUserDevicesControllerDeleteDevice<TData = void>(userId: number,
    deviceId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffUserDevicesControllerDeleteDevice<TData = void>(userId: number,
    deviceId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffUserDevicesControllerDeleteDevice<TData = void>(
    userId: number,
    deviceId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/staff/users/${userId}/devices/${deviceId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/staff/users/${userId}/devices/${deviceId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/staff/users/${userId}/devices/${deviceId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 영구 실패한 webhook 이벤트 목록 (커서 페이지네이션)
 */
 webhookEventAdminControllerList<TData = ListWebhookEventsResponseDto>(params?: WebhookEventAdminControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 webhookEventAdminControllerList<TData = ListWebhookEventsResponseDto>(params?: WebhookEventAdminControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 webhookEventAdminControllerList<TData = ListWebhookEventsResponseDto>(params?: WebhookEventAdminControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  webhookEventAdminControllerList<TData = ListWebhookEventsResponseDto>(
    params?: WebhookEventAdminControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/webhook-events`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/webhook-events`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/webhook-events`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 실패한 webhook 이벤트 상세
 */
 webhookEventAdminControllerGet<TData = WebhookEventDetailDto>(taskId: string, options?: HttpClientBodyOptions): Observable<TData>;
 webhookEventAdminControllerGet<TData = WebhookEventDetailDto>(taskId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 webhookEventAdminControllerGet<TData = WebhookEventDetailDto>(taskId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  webhookEventAdminControllerGet<TData = WebhookEventDetailDto>(
    taskId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/webhook-events/${taskId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/webhook-events/${taskId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/webhook-events/${taskId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 영구 실패한 webhook 이벤트 수동 재시도
 */
 webhookEventAdminControllerReplay<TData = ReplayWebhookEventResponseDto>(taskId: string, options?: HttpClientBodyOptions): Observable<TData>;
 webhookEventAdminControllerReplay<TData = ReplayWebhookEventResponseDto>(taskId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 webhookEventAdminControllerReplay<TData = ReplayWebhookEventResponseDto>(taskId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  webhookEventAdminControllerReplay<TData = ReplayWebhookEventResponseDto>(
    taskId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/webhook-events/${taskId}/replay`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/webhook-events/${taskId}/replay`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/webhook-events/${taskId}/replay`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

};
